import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const LanguageContext = createContext();

const SUPPORTED_LANGS = [
  { code: 'bg', label: 'BG', flag: 'BG', name: 'Български' },
  { code: 'en', label: 'EN', flag: 'EN', name: 'English' },
  { code: 'tr', label: 'TR', flag: 'TR', name: 'Türkçe' },
  { code: 'el', label: 'ΕΛ', flag: 'EL', name: 'Ελληνικά' }
];

const translations = {
  bg: {
    'properties.all_types': 'Всички типове',
    'properties.type_residential': 'Жилищен',
    'properties.type_commercial': 'Бизнес',
    'properties.type_hotel': 'Хотел',
    'properties.type_other': 'Други',
    'properties.sort_newest': 'Най-нови',
    'properties.sort_oldest': 'Най-стари',
    'properties.load_error': 'Грешка при зареждане на проектите',
    'properties.load_error_hint': 'Моля, опреснете страницата или опитайте по-късно.',
    'properties.refresh': 'Опресни',
    'properties.no_results': 'Няма намерени проекти',
    'properties.no_results_hint': 'Опитай с различни критерии за търсене',
    'properties.filtered': 'филтрирано',
    'properties.search_placeholder': 'Търси по име, локация, описание...',
    'properties.category': 'Категория',
    'properties.of': 'от',
    'properties.projects_word': 'проекта',
    'property.documents': 'Документи',
    'property.follow': 'Следете проекта',
    'property.document': 'Документ',
    'common.gallery': 'Галерия',
    'common.link': 'Линк',
    'map.title': 'Карта на проектите',
    'map.project': 'проект',
    'map.projects': 'проекта',
    'about.file_unavailable': 'Файлът не е достъпен',
    'seo.home_title': 'Нови жилищни проекти в София',
    'seo.home_desc': 'GreenCastle — модерни жилищни комплекси в София. Апартаменти в строеж и завършени проекти на изгодни цени.',
    'seo.home_h1': 'Нови жилищни проекти и апартаменти в София от GreenCastle',
    'seo.about_desc': 'Научете повече за GreenCastle — водещ строителен предприемач в София.',
    'seo.contact_desc': 'Свържете се с GreenCastle за запитвания и информация.',
    'seo.listings_desc': 'Обяви за продажба и наем на имоти от GreenCastle.',
    'seo.properties_desc': 'Разгледайте всички жилищни проекти на GreenCastle в София.',
    // Nav
    'nav.home': 'Начало',
    'nav.services': 'Услуги',
    'nav.projects': 'Проекти',
    'nav.listings': 'Имоти',
    'nav.about': 'За нас',
    'nav.contact': 'Контакти',
    'nav.login': 'Вход',
    'nav.admin': 'Админ панел',
    'nav.logout': 'Изход',

    // Home
    'home.build_dream': 'Изградете мечтания дом',
    'home.contact_us': 'Свържи се с нас',
    'home.our_services': 'Нашите услуги',
    'home.services_short': 'Предлагаме пълен спектър от услуги в областта на строителството',
    'home.view_all_services': 'Виж всички услуги',
    'home.projects_title': 'Нашите проекти',
    'home.projects_subtitle': 'Открийте вашия нов дом в един от нашите комплекси',
    'home.view_details': 'Виж детайли',
    'home.view_all_projects': 'Виж всички проекти',
    'home.view_all': 'Виж всички',
    'home.project_locations': 'Локации на проектите',
    'home.locations_subtitle': 'Всички наши проекти са на стратегически места в София',
    'home.partners_title': 'Нашите партньори',
    'home.partners_subtitle': 'Като всяка една компания ние имаме своите верни партньори в нашата работа',
    'home.cta_title': 'Готови ли сте да намерите вашия нов дом?',
    'home.cta_subtitle': 'Не се колебайте да се свържете с нас незабавно, за да отправите своето запитване.',
    'home.cta_contact': 'Свържете се с нас',
    'home.svc_design': 'Проектиране',
    'home.svc_design_desc': 'Чрез своя опит в проектирането и погледът върху най-добрите строителни практики Green Castle предлага на своите клиенти икономически най-изгодните решения.',
    'home.svc_construction': 'Строителство',
    'home.svc_construction_desc': 'На всеки етап от строително-ремонтните работи ние гарантираме високо качество на извършваната от нас услуга, съобразно Европейските стандарти.',
    'home.svc_individual': 'Индивидуален подход',
    'home.svc_individual_desc': 'Имате възможност да изберете най-подходящия за вас от проектите на Green Castle като ние се съобразяваме изцяло с потребностите и вкусовете на нашите клиенти.',

    // Properties
    'properties.title': 'Нашите проекти',
    'properties.subtitle': 'Разгледайте всички жилищни комплекси и проекти на GreenCastle. Изберете вашия бъдещ дом на невероятни цени и качество.',
    'properties.search': 'Търсене по име или локация...',
    'properties.filter_all': 'Всички',
    'properties.status_active': 'В строеж',
    'properties.status_upcoming': 'Предстоящи',
    'properties.status_sold': 'Продадени',
    'properties.status_completed': 'Завършени',
    'properties.cat_residential': 'Жилищни',
    'properties.cat_commercial': 'Бизнес',
    'properties.cat_hotel': 'Хотели',
    'properties.showing': 'Показани',
    'properties.of': 'от',
    'properties.projects_word': 'проекта',
    'properties.no_results': 'Няма намерени проекти по зададените критерии.',

    // Property Detail
    'property.back': 'Обратно към проекти',
    'property.overview': 'Общ преглед',
    'property.apartments': 'Апартаменти',
    'property.gallery': 'Галерия',
    'property.location': 'Локация',
    'property.about_project': 'За проекта',
    'property.buildings': 'Сгради в комплекса',
    'property.floors': 'етажа',
    'property.select_building': 'Изберете сграда',
    'property.floors_and_apts': 'Етажи и апартаменти',
    'property.floor': 'Етаж',
    'property.apt': 'Ап.',
    'property.area': 'м²',
    'property.rooms': 'стаи',
    'property.available': 'Свободен',
    'property.reserved': 'Резервиран',
    'property.sold': 'Продаден',
    'property.in_construction': 'В строеж',
    'property.completed': 'Завършен',
    'property.inquiry_btn': 'Запитване за този апартамент',
    'property.send_inquiry': 'Изпратете запитване',
    'property.not_found': 'Проектът не е намерен',
    'property.no_apartments': 'Все още няма добавени апартаменти към този проект.',
    'property.no_photos': 'Все още няма качени снимки за този проект.',
    'property.photos_from_admin': 'Снимките се добавят от администраторския панел.',
    'property.project_location': 'Локация на проекта',
    'property.photos': 'снимки',
    'property.plan': 'план',
    'property.blueprint': 'Чертеж на сграда',
    'property.floor_plan': 'План на Етаж',
    'property.photos_of': 'Снимки на',
    'property.photos_apt': 'Снимки - Ап.',
    'property.features': 'Характеристики',
    'property.number': 'Номер',
    'property.area_label': 'Площ',
    'property.rooms_label': 'Стаи',
    'property.status': 'Статус',
    'property.price': 'Цена',
    'property.residential': 'Жилищен комплекс',
    'property.apartments_count': 'апартамента',

    // Listings
    'listings.title': 'Обяви за имоти',
    'listings.subtitle': 'Разгледайте нашите актуални предложения за продажба и отдаване под наем.',
    'listings.search': 'Търсене по заглавие или локация...',
    'listings.all': 'Всички',
    'listings.all_categories': 'Всички категории',
    'listings.sale': 'Продажба',
    'listings.rent': 'Под наем',
    'listings.found': 'Намерени',
    'listings.results': 'обяви',
    'listings.no_results': 'Няма намерени обяви',
    'listings.try_filters': 'Опитайте с различни филтри',
    'listings.per_month': '/мес',
    'listings.description': 'Описание',
    'listings.contact': 'Контакт',
    'listings.call': 'Обади се',
    'listings.back': 'Обратно към обяви',
    'listings.not_found': 'Обявата не е намерена',
    'listings.price': 'Цена',
    'listings.area': 'Площ',
    'listings.rooms_label': 'Стаи',
    'listings.floor_label': 'Етаж',
    'listings.year': 'Година',
    'listings.gallery': 'Галерия',
    'listings.location': 'Локация',

    // Categories
    'cat.apartment': 'Апартамент',
    'cat.house': 'Къща',
    'cat.villa': 'Вила',
    'cat.land': 'Парцел',
    'cat.office': 'Офис',
    'cat.commercial': 'Търговски обект',
    'cat.garage': 'Гараж',
    'cat.studio': 'Студио',
    'cat.project': 'Проект',

    // Services
    'services.title': 'Нашите услуги',
    'services.subtitle': 'Предлагаме пълен спектър от услуги в сферата на строителството и недвижимите имоти.',
    'services.hero_subtitle': 'Green CASTLE развива дейност в областта на проучването, проектирането, изграждането на сгради и търговията с недвижими имоти.',
    'services.main_activities': 'Основни дейности',
    'services.construction_repair': 'Строително-ремонтни услуги',
    'services.construction_repair_sub': 'Разчитайте на нас и нашия екип от опитни специалисти, които могат да предоставят ремонтната услуга, от която се нуждаете.',
    'services.cta_title': 'Нашият екип ще изпълни всички ваши проекти',
    'services.cta_sub': 'Ние сме на разположение за вас, когато имате нужда от нас.',
    'services.contact_us': 'Свържете се с нас',
    'svc.design': 'Проектиране',
    'svc.design_desc': 'Чрез своя опит в проектирането и погледът върху най-добрите строителни практики Green Castle предлага на своите клиенти икономически най-изгодните решения.',
    'svc.construction': 'Строителство',
    'svc.construction_desc': 'На всеки етап от строително-ремонтните работи ние гарантираме високо качество на извършваната от нас услуга, съобразно Европейските стандарти.',
    'svc.residential': 'Жилищни сгради',
    'svc.residential_desc': 'Можете да разчитате на нас за проектиране и изграждане на вашия уютен дом.',
    'svc.business': 'Бизнес сгради и хотели',
    'svc.business_desc': 'Заедно ще изберем най-подходящата инвестиция за Вас или вашия бизнес.',
    'svc.masonry': 'Зидария',
    'svc.masonry_desc': 'Зидарията в строителството остава предпочитана поради своята стабилност, дълговечност и традиция.',
    'svc.plastering': 'Шпакловка',
    'svc.plastering_desc': 'Шпакловката представлява прахообразна или готова смес, която след нанасяне и изсъхване формира завършващ слой.',
    'svc.painting': 'Боядисване',
    'svc.painting_desc': 'Върху избора на цвят при боядисване на помещенията оказват влияние различни фактори.',
    'svc.tiling': 'Лепене на плочки',
    'svc.tiling_desc': 'Лепенето на плочки е процес, който се прави през честите етапи от ремонта.',
    'svc.drywall': 'Гипсокартон',
    'svc.drywall_desc': 'Гипсокартонът е един от материалите, които направиха революция в съвременното строителство.',
    'svc.insulation': 'Топлоизолация',
    'svc.insulation_desc': 'Топлоизолацията е основен компонент на съвременното строителство.',
    'svc.plumbing': 'ВиК услуги',
    'svc.plumbing_desc': 'ВиК услугите са много търсени. За да не ви се случва авария, потърсете специалист.',
    'svc.electrical': 'Ел. услуги',
    'svc.electrical_desc': 'Ел. услугите започват още с проекта на новия дом или с планирането на ремонта.',
    'svc.demolition': 'Къртене и извозване',
    'svc.demolition_desc': 'Нашата фирма предлага къртене, чистене и извозване на отпадъците до депо.',

    // About
    'about.title': 'За GreenCastle',
    'about.hero_subtitle': 'Компанията ни е изцяло фокусирана върху изграждането на модерни, функционални и реализирани с високо качество жилищни проекти.',
    'about.reliable_partner': 'Вашият надежден партньор в строителството',
    'about.text1': 'GreenCastle е компания с дългогодишен опит в проектирането и строителството на жилищни сгради.',
    'about.text2': 'Ние се ангажираме да предоставим на нашите клиенти най-високото качество на строителство.',
    'about.text3': 'Нашата мисия е да изграждаме домове, които надхвърлят очакванията на нашите клиенти.',
    'about.years_exp': 'години опит',
    'about.values_title': 'Нашите ценности',
    'about.values_subtitle': 'Принципите, които ни водят в работата ни',
    'about.quality': 'Качество',
    'about.quality_desc': 'На всеки етап гарантираме високо качество на услугата съобразно Европейските стандарти.',
    'about.precision': 'Прецизност',
    'about.precision_desc': 'Предлагаме икономически най-изгодните решения чрез опита ни в проектирането.',
    'about.customer_care': 'Грижа за клиента',
    'about.customer_care_desc': 'Изцяло се съобразяваме с потребностите и вкусовете на нашите клиенти.',
    'about.reliability': 'Надеждност',
    'about.reliability_desc': 'Освен за качество, даваме гаранция и за срок на изпълнение. Винаги спазваме обещанията си.',
    'about.certs_title': 'Сертификати и удостоверения',
    'about.certs_subtitle': 'Нашите постижения и сертификации',
    'about.team_title': 'Нашият екип',
    'about.team_subtitle': 'Професионалисти с богат опит в строителството и архитектурата',
    'about.partners_title': 'Нашите партньори',
    'about.partners_subtitle': 'Работим с водещи компании в бранша',

    // Contact
    'contact.title': 'Свържете се с нас',
    'contact.subtitle': 'Нашият екип е на разположение за вас.',
    'contact.info_title': 'Информация за контакт',
    'contact.address': 'Адрес',
    'contact.phone': 'Телефон',
    'contact.email': 'Имейл',
    'contact.working_hours': 'Работно време',
    'contact.hours_value': 'Пон - Пет: 9:00 - 18:00',
    'contact.sales_dept': 'Отдел продажби',
    'contact.find_us': 'Намерете ни',
    'contact.form_title': 'Изпратете запитване',
    'contact.form_subtitle': 'Попълнете формата и ние ще се свържем с вас възможно най-скоро.',

    // Inquiry Form
    'form.name': 'Вашето име',
    'form.email': 'Имейл',
    'form.phone': 'Телефон',
    'form.message': 'Съобщение',
    'form.submit': 'Изпрати запитване',
    'form.sending': 'Изпращане...',
    'form.success_title': 'Благодарим Ви!',
    'form.success_msg': 'Вашето запитване беше изпратено успешно. Ще се свържем с Вас скоро.',
    'form.new_inquiry': 'Изпрати ново запитване',
    'form.inquiry_for': 'Запитване за',
    'form.min_length': 'Съобщението трябва да е поне 10 символа.',
    'form.too_many': 'Твърде много заявки. Моля, изчакайте няколко минути.',
    'form.error': 'Грешка при изпращане на запитването. Моля, опитайте отново.',
    'form.placeholder_name': 'Иван Иванов',
    'form.placeholder_email': 'ivan@example.com',
    'form.placeholder_phone': '+359 888 123 456',
    'form.placeholder_message': 'Интересувам се от повече информация за...',

    // Login
    'login.title': 'Вход в системата',
    'login.subtitle': 'Въведете вашите данни за достъп',
    'login.email': 'Имейл',
    'login.password': 'Парола',
    'login.submit': 'Вход',
    'login.loading': 'Влизане...',
    'login.back': 'Обратно към сайта',
    'login.success': 'Успешен вход!',
    'login.error': 'Нещо се обърка. Моля, опитайте отново.',

    // Footer
    'footer.description': 'Компанията ни е изцяло фокусирана върху изграждането на модерни, функционални и реализирани с високо качество жилищни проекти.',
    'footer.quick_links': 'Бързи връзки',
    'footer.our_projects': 'Нашите проекти',
    'footer.current_projects': 'Текущи проекти',
    'footer.contacts': 'Контакти',
    'footer.privacy': 'Политика за поверителност',
    'footer.terms': 'Условия за ползване',
    'footer.rights': 'Всички права запазени.',
    'footer.loading': 'Зареждане...',
    'footer.sales_dept': 'Отдел продажби',

    // Admin Navigation
    // ── Admin Page Translations ──────────────────────────────
    'settings.page_title': 'Настройки на сайта',
    'settings.page_subtitle': 'Управлявайте основните настройки, Hero slideshow и Google Maps',
    'settings.save_all': 'Запази всички промени',
    'settings.saved': 'Настройките са запазени!',
    'settings.save_error': 'Грешка при запазване',
    'settings.tab.hero': 'Hero Slideshow',
    'settings.tab.contact': 'Контакти и локация',
    'settings.tab.maps': 'Google Maps',
    'settings.tab.ai': 'AI Интеграция',
    'settings.slideshow.subtitle': 'Слайдовете се показват на началната страница',
    'settings.slideshow.add_slide': 'Добави слайд',
    'settings.slideshow.settings': 'Настройки на слайдшоу',
    'settings.slideshow.speed': 'Скорост (секунди)',
    'settings.slideshow.order': 'Ред на показване',
    'settings.slideshow.sequential': 'Последователно',
    'settings.slideshow.random': 'Случаен ред',
    'settings.slideshow.transition': 'Преход',
    'settings.slideshow.fade': 'Плавен (fade)',
    'settings.slideshow.slide': 'Слайд',
    'settings.slideshow.autoplay': 'Автоматична смяна',
    'settings.image': 'Изображение',
    'settings.image_url': 'URL на изображението',
    'settings.title_label': 'Заглавие',
    'settings.title_placeholder': 'Заглавие на слайда',
    'settings.subtitle_label': 'Подзаглавие / Описание',
    'settings.subtitle_placeholder': 'Кратко описание',
    'settings.cta_text': 'Текст на бутона',
    'settings.cta_link': 'Линк на бутона',
    'settings.no_slides': 'Няма добавени слайдове',
    'settings.add_first_slide': 'Добави първия слайд',
    'settings.contact.title': 'Контактна информация',
    'settings.contact.address': 'Адрес на офиса',
    'settings.contact.phone_office': 'Телефон (офис)',
    'settings.contact.email_office': 'Имейл (офис)',
    'settings.contact.phone_sales': 'Телефон (продажби)',
    'settings.contact.email_sales': 'Имейл (продажби)',
    'settings.contact.extra_phone_1': 'Допълнителен телефон 1',
    'settings.contact.extra_email_1': 'Допълнителен имейл 1',
    'settings.contact.extra_phone_2': 'Допълнителен телефон 2',
    'settings.contact.extra_email_2': 'Допълнителен имейл 2',
    'settings.contact.optional': 'Оставете празно ако не е нужно',
    'settings.contact.extra_socials': 'Допълнителни социални мрежи',
    'settings.contact.add_network': 'Добави мрежа',
    'settings.location.title': 'Локация на офиса',
    'settings.location.subtitle': 'Координатите определят позицията на картата',
    'settings.location.lat': 'Latitude (ширина)',
    'settings.location.lng': 'Longitude (дължина)',
    'settings.location.map_preview': 'Преглед на картата',
    'settings.maps.title': 'Google Maps API Ключ',
    'settings.maps.api_key_label': 'API Ключ',
    'settings.ai.section_title': 'AI Интеграция',
    'settings.tracking.title': 'Tracking & Анализ',
    'props.page_title': 'Управление на имоти',
    'props.page_subtitle': 'Проекти, сгради, етажи и апартаменти',
    'props.new_project': 'Нов проект',
    'props.edit_project': 'Редактиране на проект',
    'props.add_building': 'Сграда',
    'props.category': 'Категория',
    'props.status.active': 'В строеж',
    'props.status.upcoming': 'Предстоящ',
    'props.status.completed': 'Завършен',
    'props.cat.residential': 'Жилищен',
    'props.cat.commercial': 'Бизнес',
    'props.cat.hotel': 'Хотел',
    'props.images_hint': '1-ва = Лого · 2-ра = Cover · плъзни за ред',
    'props.documents': 'Документи',
    'props.social_networks': 'Социални мрежи',
    'props.uploading': 'Качване...',
    'props.create': 'Създай',
    'props.edit_building': 'Редактиране на сграда',
    'props.new_building': 'Нова сграда',
    'props.edit_floor': 'Редактиране на етаж',
    'props.new_floor': 'Нов етаж',
    'props.edit_apt': 'Редактиране на апартамент',
    'props.new_apt': 'Нов апартамент',
    'props.apt.available': 'Свободен',
    'props.apt.reserved': 'Резервиран',
    'props.apt.sold': 'Продаден',
    'props.floor_number': 'Номер на етаж',
    'props.floor_description': 'Описание на етажа',
    'props.floor_photos': 'Снимки на общите части',
    'props.apt_number': 'Номер',
    'dashboard.morning': 'Добро утро',
    'dashboard.afternoon': 'Добър ден',
    'dashboard.evening': 'Добър вечер',
    'dashboard.welcome': 'Добре дошъл',
    'dashboard.manage_listings': 'Управлявай своите обяви',
    'dashboard.last_6months': 'последните 6 месеца',
    'dashboard.inquiries_by_month': 'Запитвания по месеци',
    'dashboard.by_status': 'Разпределение по статус',
    'dashboard.latest_inquiries': 'Последни запитвания',
    'dashboard.quick_actions': 'Бързи действия',
    'listings.admin_title': 'Обяви за имоти',
    'listings.new_listing': 'Нова обява',
    'listings.edit_listing': 'Редактиране на обява',
    'listings.area_label': 'Площ',
    'listings.rooms_label': 'Стаи',
    'listings.floor_label': 'Етаж',
    'listings.year_label': 'Година',
    'listings.features': 'Характеристики',
    'listings.sale_or_rent': 'Продажба или наем',
    'inquiries.title': 'Запитвания',
    'inquiries.email_notifs': 'Имейл нотификации',
    'inquiries.all': 'Всички',
    'inquiries.new': 'Нови',
    'inquiries.read': 'Прочетени',
    'inquiries.replied': 'Отговорени',
    'inquiries.send_test': 'Изпрати тест',
    'inquiries.save_settings': 'Запази настройки',
    'inquiries.recipients': 'Получатели на нотификации',
    'inquiries.smtp_settings': 'SMTP Настройки',
    'inquiries.smtp_server': 'SMTP Сървър',
    'inquiries.smtp_port': 'Порт',
    'inquiries.smtp_user': 'Потребител',
    'inquiries.smtp_password': 'Парола',
    'inquiries.smtp_sender': 'Изпращач',
    'inquiries.no_inquiries': 'Няма запитвания',
    'inquiries.status.new': 'Ново',
    'inquiries.status.read': 'Прочетено',
    'inquiries.status.replied': 'Отговорено',
    'users.title': 'Потребители',
    'users.new_user': 'Нов потребител',
    'users.edit_user': 'Редактиране на потребител',
    'users.system_account': 'Системен акаунт',
    'users.change_password': 'Смяна на парола',
    'users.role.admin': 'Администратор',
    'users.role.manager': 'Мениджър',
    'users.role.editor': 'Редактор',
    'users.role.broker': 'Брокер',
    'about_admin.title': 'За нас',
    'about_admin.team': 'Екип',
    'about_admin.partners': 'Партньори',
    'about_admin.certificates': 'Сертификати',
    'about_admin.add_member': 'Добави член',
    'about_admin.add_partner': 'Добави партньор',
    'about_admin.add_cert': 'Добави сертификат',
    'services_admin.title': 'Услуги',
    'about_admin.page_title': 'Страница За нас',
    'about_admin.page_subtitle': 'Управлявайте съдържанието на страницата',
    'about_admin.description': 'Описание',
    'about_admin.company_text': 'Текст за компанията',
    'about_admin.our_team': 'Нашият екип',
    'about_admin.certifications': 'Сертификати и удостоверения',
    'inquiries.page_subtitle': 'Преглед и управление на запитвания',
    'inquiries.activate_notifs': 'Активирай имейл нотификации',
    'inquiries.no_recipients': 'Няма добавени получатели',
    'inquiries.send_test_email': 'Изпрати тестов имейл',
    'services_admin.subtitle': 'Управление на услугите',
    'services_admin.icon': 'Иконка',
    'reports.title': 'Репорти и Логове',
    'reports.no_reports': 'Няма създадени репорти',
    'reports.view_report': 'Преглед на репорта',
    'reports.period': 'Данни за период',
    'reports.format': 'Формат',
    'common.close': 'Затвори',
    'common.cancel': 'Отказ',
    'common.save': 'Запази',
    'common.add': 'Добави',
    'common.delete': 'Изтрий',
    'common.edit': 'Редактирай',
    'common.loading': 'Зареждане...',
    'common.no_data': 'Няма данни',
    'props.project_name': 'Иme на проекта',
    'props.building_name': 'Иme на сградата',
    'props.floors_count': 'Брой етажи',
    'props.blueprint': 'Чертеж / План',
    'props.building_photos': 'Снимки на сградата',
    'props.apts_count': 'Брой апартаменти',
    'props.upload_btn': 'Качи',
    'props.upload_blueprint': 'Качи чертеж',
    'inquiries.sender_name': 'Иme на изпращач',
    'inquiries.use_tls': 'Използвай TLS/SSL',
    'dashboard.apartments': 'Апартаменти',
    'dashboard.residential_complexes': 'жилищни комплекси',
    'dashboard.in_all_projects': 'в всички проекти',
    'dashboard.sale_and_rent': 'продажба и наем',
    'dashboard.from_clients': 'от клиенти',
    'listings.neighborhood_label': 'Квартал',
    'listings.neighborhood_hint': 'Само квартал — напр. Лозенец, Изток, Младост',
    'listings.all_neighborhoods': 'Всички квартали',
    'listings.in_neighborhood': 'в квартал',
    'listings.clear_filters': 'Изчисти филтри',
    'admin.panel': 'Админ панел',
    'admin.dashboard': 'Табло',
    'admin.main': 'Главно',
    'admin.site': 'Сайт',
    'admin.settings': 'Настройки (Начало)',
    'admin.projects': 'Проекти',
    'admin.listings_nav': 'Обяви за имоти',
    'admin.services_nav': 'Услуги',
    'admin.about_nav': 'За нас',
    'admin.contacts_section': 'Контакти и запитвания',
    'admin.contacts_nav': 'Контакти',
    'admin.inquiries_nav': 'Запитвания',
    'admin.reports_nav': 'Репорти',
    'admin.administration': 'Администрация',
    'admin.users_nav': 'Потребители',
    'admin.view_site': 'Виж сайта',
    'admin.language': 'Език',
    // Admin Actions
    'admin.save': 'Запази',
    'admin.cancel': 'Откажи',
    'admin.delete': 'Изтрий',
    'admin.edit': 'Редактирай',
    'admin.add': 'Добави',
    'admin.create': 'Създай',
    'admin.search': 'Търсене...',
    'admin.confirm_delete': 'Сигурни ли сте, че искате да изтриете?',
    'admin.yes_delete': 'Да, изтрий',
    'admin.no_cancel': 'Не, откажи',
    'admin.loading': 'Зареждане...',
    'admin.saving': 'Запазване...',
    'admin.success': 'Успешно запазено!',
    'admin.error': 'Грешка. Опитайте отново.',
    'admin.no_data': 'Няма данни',
    'admin.status': 'Статус',
    'admin.actions': 'Действия',
    'admin.preview': 'Преглед',
    'admin.upload_image': 'Качи снимка',
    'admin.drag_reorder': 'Плъзнете за пренареждане',
    'admin.cover_photo': 'Основна снимка',
    'listings.type_label': 'Тип обява',
    'listings.admin_subtitle': 'Управлявайте обяви за продажба и наем',
    'listings.broker_own_only': 'Виждате само своите обяви',
    'listings.no_listings': 'Няма обяви',
    'listings.create_first': 'Създайте първата обява за имот',
    'listings.contact_name': 'Контакт - Иme',
    'listings.contact_phone': 'Контакт - Телефон',
    'listings.contact_email': 'Контакт - Имейл',
    'listings.features_hint': 'Разделете с запетая: Паркомясто, Асансьор, Балкон',
    'listings.all_cities': 'Всички градове',
    'listings.all_neighborhoods': 'Всички квартали',
    'listings.in_neighborhood': 'в квартал',
    'listings.clear_filters': 'Изчисти филтри',
    'listings.neighborhood_label': 'Квартал',
    'listings.neighborhood_hint': 'Само квартал — напр. Лозенец, Изток, Младост',
    'admin.title': 'Заглавие',
    'admin.location': 'Локация / Град',
    'admin.description': 'Описание',
    'admin.name': 'Иme',
    'admin.email': 'Имейл',
    'admin.phone': 'Телефон',
    'admin.role': 'Роля',
    'admin.price': 'Цена',
    'admin.created_at': 'Създадено на',
    'admin.add_new': 'Добави нов',
    'admin.upload_images': 'Качи снимки',
  },

  en: {
    'properties.all_types': 'All types',
    'properties.type_residential': 'Residential',
    'properties.type_commercial': 'Commercial',
    'properties.type_hotel': 'Hotel',
    'properties.type_other': 'Other',
    'properties.sort_newest': 'Newest',
    'properties.sort_oldest': 'Oldest',
    'properties.load_error': 'Error loading projects',
    'properties.load_error_hint': 'Please refresh the page or try again later.',
    'properties.refresh': 'Refresh',
    'properties.no_results': 'No projects found',
    'properties.no_results_hint': 'Try different search criteria',
    'properties.filtered': 'filtered',
    'properties.search_placeholder': 'Search by name, location, description...',
    'properties.category': 'Category',
    'properties.of': 'of',
    'properties.projects_word': 'projects',
    'property.documents': 'Documents',
    'property.follow': 'Follow the project',
    'property.document': 'Document',
    'common.gallery': 'Gallery',
    'common.link': 'Link',
    'map.title': 'Project locations',
    'map.project': 'project',
    'map.projects': 'projects',
    'about.file_unavailable': 'File is not available',
    'seo.home_title': 'New residential projects in Sofia',
    'seo.home_desc': 'GreenCastle — modern residential complexes in Sofia. Apartments under construction and completed projects at great prices.',
    'seo.home_h1': 'New residential projects and apartments in Sofia by GreenCastle',
    'seo.about_desc': 'Learn more about GreenCastle — a leading construction developer in Sofia.',
    'seo.contact_desc': 'Contact GreenCastle for inquiries and information.',
    'seo.listings_desc': 'Property listings for sale and rent by GreenCastle.',
    'seo.properties_desc': 'Browse all GreenCastle residential projects in Sofia.',
    'nav.home': 'Home',
    'nav.services': 'Services',
    'nav.projects': 'Projects',
    'nav.listings': 'Properties',
    'nav.about': 'About Us',
    'nav.contact': 'Contacts',
    'nav.login': 'Login',
    'nav.admin': 'Admin Panel',
    'nav.logout': 'Logout',

    'home.build_dream': 'Build your dream home',
    'home.contact_us': 'Contact us',
    'home.our_services': 'Our Services',
    'home.services_short': 'We offer a full range of services in construction',
    'home.view_all_services': 'View all services',
    'home.projects_title': 'Our Projects',
    'home.projects_subtitle': 'Discover your new home in one of our complexes',
    'home.view_details': 'View details',
    'home.view_all_projects': 'View all projects',
    'home.view_all': 'View all',
    'home.project_locations': 'Project Locations',
    'home.locations_subtitle': 'All our projects are at strategic locations in Sofia',
    'home.partners_title': 'Our Partners',
    'home.partners_subtitle': 'Like every company, we have our trusted partners',
    'home.cta_title': 'Ready to find your new home?',
    'home.cta_subtitle': 'Do not hesitate to contact us immediately with your inquiry.',
    'home.cta_contact': 'Contact Us',
    'home.svc_design': 'Design',
    'home.svc_design_desc': 'Through our experience in design and knowledge of the best construction practices, Green Castle offers its clients the most cost-effective solutions.',
    'home.svc_construction': 'Construction',
    'home.svc_construction_desc': 'At every stage of construction and renovation work, we guarantee high quality service in compliance with European standards.',
    'home.svc_individual': 'Individual Approach',
    'home.svc_individual_desc': 'You have the opportunity to choose the most suitable project from Green Castle as we fully comply with the needs and tastes of our clients.',

    'properties.title': 'Our Projects',
    'properties.subtitle': 'Browse all residential complexes and projects by GreenCastle.',
    'properties.search': 'Search by name or location...',
    'properties.filter_all': 'All',
    'properties.status_active': 'Under Construction',
    'properties.status_upcoming': 'Upcoming',
    'properties.status_sold': 'Sold',
    'properties.status_completed': 'Completed',
    'properties.cat_residential': 'Residential',
    'properties.cat_commercial': 'Commercial',
    'properties.cat_hotel': 'Hotels',
    'properties.showing': 'Showing',
    'properties.of': 'of',
    'properties.projects_word': 'projects',
    'properties.no_results': 'No projects found matching the criteria.',

    'property.back': 'Back to projects',
    'property.overview': 'Overview',
    'property.apartments': 'Apartments',
    'property.gallery': 'Gallery',
    'property.location': 'Location',
    'property.about_project': 'About the project',
    'property.buildings': 'Buildings in the complex',
    'property.floors': 'floors',
    'property.select_building': 'Select building',
    'property.floors_and_apts': 'Floors and apartments',
    'property.floor': 'Floor',
    'property.apt': 'Apt.',
    'property.area': 'sq.m.',
    'property.rooms': 'rooms',
    'property.available': 'Available',
    'property.reserved': 'Reserved',
    'property.sold': 'Sold',
    'property.in_construction': 'Under Construction',
    'property.completed': 'Completed',
    'property.inquiry_btn': 'Inquire about this apartment',
    'property.send_inquiry': 'Send an Inquiry',
    'property.not_found': 'Project not found',
    'property.no_apartments': 'No apartments added to this project yet.',
    'property.no_photos': 'No photos uploaded for this project yet.',
    'property.photos_from_admin': 'Photos are added from the admin panel.',
    'property.project_location': 'Project location',
    'property.photos': 'photos',
    'property.plan': 'plan',
    'property.blueprint': 'Building blueprint',
    'property.floor_plan': 'Floor Plan',
    'property.photos_of': 'Photos of',
    'property.photos_apt': 'Photos - Apt.',
    'property.features': 'Features',
    'property.number': 'Number',
    'property.area_label': 'Area',
    'property.rooms_label': 'Rooms',
    'property.status': 'Status',
    'property.price': 'Price',
    'property.residential': 'Residential complex',
    'property.apartments_count': 'apartments',

    'listings.title': 'Property Listings',
    'listings.subtitle': 'Browse our current offers for sale and rent.',
    'listings.search': 'Search by title or location...',
    'listings.all': 'All',
    'listings.all_categories': 'All categories',
    'listings.sale': 'For Sale',
    'listings.rent': 'For Rent',
    'listings.found': 'Found',
    'listings.results': 'listings',
    'listings.no_results': 'No listings found',
    'listings.try_filters': 'Try different filters',
    'listings.per_month': '/mo',
    'listings.description': 'Description',
    'listings.contact': 'Contact',
    'listings.call': 'Call',
    'listings.back': 'Back to listings',
    'listings.not_found': 'Listing not found',
    'listings.price': 'Price',
    'listings.area': 'Area',
    'listings.rooms_label': 'Rooms',
    'listings.floor_label': 'Floor',
    'listings.year': 'Year',
    'listings.gallery': 'Gallery',
    'listings.location': 'Location',

    'cat.apartment': 'Apartment',
    'cat.house': 'House',
    'cat.villa': 'Villa',
    'cat.land': 'Land',
    'cat.office': 'Office',
    'cat.commercial': 'Commercial',
    'cat.garage': 'Garage',
    'cat.studio': 'Studio',
    'cat.project': 'Project',

    'services.title': 'Our Services',
    'services.subtitle': 'We offer a full range of services in construction and real estate.',
    'services.hero_subtitle': 'Green CASTLE operates in the field of research, design, construction of buildings and real estate trade.',
    'services.main_activities': 'Main Activities',
    'services.construction_repair': 'Construction & Renovation Services',
    'services.construction_repair_sub': 'Count on us and our team of experienced professionals who can provide the renovation service you need.',
    'services.cta_title': 'Our team will complete all your projects',
    'services.cta_sub': 'We are at your disposal whenever you need us.',
    'services.contact_us': 'Contact Us',
    'svc.design': 'Architectural Design',
    'svc.design_desc': 'Through our experience in design and knowledge of the best construction practices, Green Castle offers its clients the most cost-effective solutions.',
    'svc.construction': 'Construction',
    'svc.construction_desc': 'At every stage of construction and renovation work, we guarantee high quality service in compliance with European standards.',
    'svc.residential': 'Residential Buildings',
    'svc.residential_desc': 'You can count on us for the design and construction of your cozy home.',
    'svc.business': 'Business Buildings & Hotels',
    'svc.business_desc': 'Together we will choose the most suitable investment for you or your business.',
    'svc.masonry': 'Masonry',
    'svc.masonry_desc': 'Masonry in construction remains preferred for its stability, durability, and tradition.',
    'svc.plastering': 'Plastering',
    'svc.plastering_desc': 'Plaster is a powder or ready-made mixture that forms a finishing layer on the treated surface.',
    'svc.painting': 'Painting',
    'svc.painting_desc': 'Various factors influence the choice of color when painting rooms.',
    'svc.tiling': 'Tile Installation',
    'svc.tiling_desc': 'Tile installation is a process that occurs during the frequent stages of renovation.',
    'svc.drywall': 'Drywall',
    'svc.drywall_desc': 'Drywall is one of the materials that revolutionized modern construction.',
    'svc.insulation': 'Thermal Insulation',
    'svc.insulation_desc': 'Thermal insulation is a key component of modern construction.',
    'svc.plumbing': 'Plumbing',
    'svc.plumbing_desc': 'Plumbing services are in high demand. Seek a specialist before it is too late.',
    'svc.electrical': 'Electrical Services',
    'svc.electrical_desc': 'Electrical services begin with the project design of a new home or renovation planning.',
    'svc.demolition': 'Demolition & Removal',
    'svc.demolition_desc': 'Our company offers demolition, cleaning, and waste removal to a depot.',

    'about.title': 'About GreenCastle',
    'about.hero_subtitle': 'Our company is fully focused on building modern, functional, and high-quality residential projects.',
    'about.reliable_partner': 'Your reliable partner in construction',
    'about.text1': 'GreenCastle is a company with years of experience in the design and construction of residential buildings.',
    'about.text2': 'We are committed to providing our clients with the highest quality of construction.',
    'about.text3': 'Our mission is to build homes that exceed our clients\u2019 expectations.',
    'about.years_exp': 'years of experience',
    'about.values_title': 'Our Values',
    'about.values_subtitle': 'The principles that guide us in our work',
    'about.quality': 'Quality',
    'about.quality_desc': 'At every stage we guarantee high quality service in compliance with European standards.',
    'about.precision': 'Precision',
    'about.precision_desc': 'We offer the most cost-effective solutions through our design experience.',
    'about.customer_care': 'Customer Care',
    'about.customer_care_desc': 'We fully comply with the needs and tastes of our clients.',
    'about.reliability': 'Reliability',
    'about.reliability_desc': 'We guarantee timely completion of services. We always keep our promises.',
    'about.certs_title': 'Certificates & Credentials',
    'about.certs_subtitle': 'Our achievements and certifications',
    'about.team_title': 'Our Team',
    'about.team_subtitle': 'Professionals with extensive experience in construction and architecture',
    'about.partners_title': 'Our Partners',
    'about.partners_subtitle': 'We work with leading companies in the industry',

    'contact.title': 'Contact Us',
    'contact.subtitle': 'Our team is at your disposal.',
    'contact.info_title': 'Contact Information',
    'contact.address': 'Address',
    'contact.phone': 'Phone',
    'contact.email': 'Email',
    'contact.working_hours': 'Working Hours',
    'contact.hours_value': 'Mon - Fri: 9:00 AM - 6:00 PM',
    'contact.sales_dept': 'Sales Department',
    'contact.find_us': 'Find Us',
    'contact.form_title': 'Send an Inquiry',
    'contact.form_subtitle': 'Fill in the form and we will contact you as soon as possible.',

    'form.name': 'Your Name',
    'form.email': 'Email',
    'form.phone': 'Phone',
    'form.message': 'Message',
    'form.submit': 'Send Inquiry',
    'form.sending': 'Sending...',
    'form.success_title': 'Thank You!',
    'form.success_msg': 'Your inquiry has been sent successfully. We will contact you soon.',
    'form.new_inquiry': 'Send new inquiry',
    'form.inquiry_for': 'Inquiry for',
    'form.min_length': 'Message must be at least 10 characters.',
    'form.too_many': 'Too many requests. Please wait a few minutes.',
    'form.error': 'Error sending inquiry. Please try again.',
    'form.placeholder_name': 'John Smith',
    'form.placeholder_email': 'john@example.com',
    'form.placeholder_phone': '+359 888 123 456',
    'form.placeholder_message': 'I am interested in more information about...',

    'login.title': 'System Login',
    'login.subtitle': 'Enter your access credentials',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.submit': 'Login',
    'login.loading': 'Logging in...',
    'login.back': 'Back to website',
    'login.success': 'Login successful!',
    'login.error': 'Something went wrong. Please try again.',

    'footer.description': 'Our company is fully focused on building modern, functional, and high-quality residential projects.',
    'footer.quick_links': 'Quick Links',
    'footer.our_projects': 'Our Projects',
    'footer.current_projects': 'Current Projects',
    'footer.contacts': 'Contacts',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Use',
    'footer.rights': 'All rights reserved.',
    'footer.loading': 'Loading...',
    'footer.sales_dept': 'Sales Department',

    // Admin Navigation
    // ── Admin Page Translations ──────────────────────────────
    'settings.page_title': 'Site Settings',
    'settings.page_subtitle': 'Manage main settings, Hero slideshow and Google Maps',
    'settings.save_all': 'Save all changes',
    'settings.saved': 'Settings saved!',
    'settings.save_error': 'Error saving',
    'settings.tab.hero': 'Hero Slideshow',
    'settings.tab.contact': 'Contacts & Location',
    'settings.tab.maps': 'Google Maps',
    'settings.tab.ai': 'AI Integration',
    'settings.slideshow.subtitle': 'Slides are shown on the homepage',
    'settings.slideshow.add_slide': 'Add slide',
    'settings.slideshow.settings': 'Slideshow Settings',
    'settings.slideshow.speed': 'Speed (seconds)',
    'settings.slideshow.order': 'Display Order',
    'settings.slideshow.sequential': 'Sequential',
    'settings.slideshow.random': 'Random',
    'settings.slideshow.transition': 'Transition',
    'settings.slideshow.fade': 'Smooth (fade)',
    'settings.slideshow.slide': 'Slide',
    'settings.slideshow.autoplay': 'Auto-play',
    'settings.image': 'Image',
    'settings.image_url': 'Image URL',
    'settings.title_label': 'Title',
    'settings.title_placeholder': 'Slide title',
    'settings.subtitle_label': 'Subtitle / Description',
    'settings.subtitle_placeholder': 'Short description',
    'settings.cta_text': 'Button Text',
    'settings.cta_link': 'Button Link',
    'settings.no_slides': 'No slides added',
    'settings.add_first_slide': 'Add first slide',
    'settings.contact.title': 'Contact Information',
    'settings.contact.address': 'Office Address',
    'settings.contact.phone_office': 'Phone (office)',
    'settings.contact.email_office': 'Email (office)',
    'settings.contact.phone_sales': 'Phone (sales)',
    'settings.contact.email_sales': 'Email (sales)',
    'settings.contact.extra_phone_1': 'Additional phone 1',
    'settings.contact.extra_email_1': 'Additional email 1',
    'settings.contact.extra_phone_2': 'Additional phone 2',
    'settings.contact.extra_email_2': 'Additional email 2',
    'settings.contact.optional': 'Leave empty if not needed',
    'settings.contact.extra_socials': 'Additional social networks',
    'settings.contact.add_network': 'Add network',
    'settings.location.title': 'Office Location',
    'settings.location.subtitle': 'Coordinates determine the map position',
    'settings.location.lat': 'Latitude',
    'settings.location.lng': 'Longitude',
    'settings.location.map_preview': 'Map Preview',
    'settings.maps.title': 'Google Maps API Key',
    'settings.maps.api_key_label': 'API Key',
    'settings.ai.section_title': 'AI Integration',
    'settings.tracking.title': 'Tracking & Analytics',
    'props.page_title': 'Properties Management',
    'props.page_subtitle': 'Projects, buildings, floors and apartments',
    'props.new_project': 'New Project',
    'props.edit_project': 'Edit Project',
    'props.add_building': 'Building',
    'props.category': 'Category',
    'props.status.active': 'Under Construction',
    'props.status.upcoming': 'Upcoming',
    'props.status.completed': 'Completed',
    'props.cat.residential': 'Residential',
    'props.cat.commercial': 'Commercial',
    'props.cat.hotel': 'Hotel',
    'props.images_hint': '1st = Logo · 2nd = Cover · drag to reorder',
    'props.documents': 'Documents',
    'props.social_networks': 'Social Networks',
    'props.uploading': 'Uploading...',
    'props.create': 'Create',
    'props.edit_building': 'Edit Building',
    'props.new_building': 'New Building',
    'props.edit_floor': 'Edit Floor',
    'props.new_floor': 'New Floor',
    'props.edit_apt': 'Edit Apartment',
    'props.new_apt': 'New Apartment',
    'props.apt.available': 'Available',
    'props.apt.reserved': 'Reserved',
    'props.apt.sold': 'Sold',
    'props.floor_number': 'Floor number',
    'props.floor_description': 'Floor description',
    'props.floor_photos': 'Photos of common areas',
    'props.apt_number': 'Number',
    'dashboard.morning': 'Good morning',
    'dashboard.afternoon': 'Good afternoon',
    'dashboard.evening': 'Good evening',
    'dashboard.welcome': 'Welcome',
    'dashboard.manage_listings': 'Manage your listings',
    'dashboard.last_6months': 'last 6 months',
    'dashboard.inquiries_by_month': 'Inquiries by Month',
    'dashboard.by_status': 'Distribution by Status',
    'dashboard.latest_inquiries': 'Latest Inquiries',
    'dashboard.quick_actions': 'Quick Actions',
    'listings.admin_title': 'Property Listings',
    'listings.new_listing': 'New Listing',
    'listings.edit_listing': 'Edit Listing',
    'listings.area_label': 'Area',
    'listings.rooms_label': 'Rooms',
    'listings.floor_label': 'Floor',
    'listings.year_label': 'Year',
    'listings.features': 'Features',
    'listings.sale_or_rent': 'Sale or Rent',
    'inquiries.title': 'Inquiries',
    'inquiries.email_notifs': 'Email Notifications',
    'inquiries.all': 'All',
    'inquiries.new': 'New',
    'inquiries.read': 'Read',
    'inquiries.replied': 'Replied',
    'inquiries.send_test': 'Send test',
    'inquiries.save_settings': 'Save settings',
    'inquiries.recipients': 'Notification recipients',
    'inquiries.smtp_settings': 'SMTP Settings',
    'inquiries.smtp_server': 'SMTP Server',
    'about_admin.page_title': 'About Us Page',
    'about_admin.page_subtitle': 'Manage page content',
    'about_admin.description': 'Description',
    'about_admin.company_text': 'Company text',
    'about_admin.our_team': 'Our Team',
    'about_admin.certifications': 'Certificates & Credentials',
    'inquiries.page_subtitle': 'View and manage inquiries',
    'inquiries.activate_notifs': 'Enable email notifications',
    'inquiries.no_recipients': 'No recipients added',
    'inquiries.send_test_email': 'Send test email',
    'services_admin.subtitle': 'Manage services',
    'services_admin.icon': 'Icon',
    'reports.title': 'Reports & Logs',
    'reports.no_reports': 'No reports created',
    'reports.view_report': 'View report',
    'reports.period': 'Period data',
    'reports.format': 'Format',
    'common.close': 'Close',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.add': 'Add',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.loading': 'Loading...',
    'common.no_data': 'No data',
    'inquiries.smtp_port': 'Port',
    'inquiries.smtp_user': 'Username',
    'inquiries.smtp_password': 'Password',
    'inquiries.smtp_sender': 'Sender',
    'inquiries.no_inquiries': 'No inquiries',
    'inquiries.status.new': 'New',
    'inquiries.status.read': 'Read',
    'inquiries.status.replied': 'Replied',
    'users.title': 'Users',
    'users.new_user': 'New User',
    'users.edit_user': 'Edit User',
    'users.system_account': 'System Account',
    'users.change_password': 'Change Password',
    'users.role.admin': 'Administrator',
    'props.project_name': 'Project Name',
    'props.building_name': 'Building Name',
    'props.floors_count': 'Number of floors',
    'props.blueprint': 'Blueprint / Plan',
    'props.building_photos': 'Building photos',
    'props.apts_count': 'Number of apartments',
    'props.upload_btn': 'Upload',
    'props.upload_blueprint': 'Upload blueprint',
    'inquiries.sender_name': 'Sender name',
    'inquiries.use_tls': 'Use TLS/SSL',
    'dashboard.apartments': 'Apartments',
    'users.role.manager': 'Manager',
    'users.role.editor': 'Editor',
    'users.role.broker': 'Broker',
    'about_admin.title': 'About Us',
    'about_admin.team': 'Team',
    'about_admin.partners': 'Partners',
    'about_admin.certificates': 'Certificates',
    'dashboard.residential_complexes': 'residential complexes',
    'dashboard.in_all_projects': 'in all projects',
    'dashboard.sale_and_rent': 'sale and rent',
    'listings.neighborhood_label': 'Neighborhood',
    'listings.neighborhood_hint': 'Neighborhood only — e.g. Lozenets, Iztok',
    'listings.all_neighborhoods': 'All neighborhoods',
    'listings.in_neighborhood': 'in neighborhood',
    'listings.clear_filters': 'Clear filters',
    'dashboard.from_clients': 'from clients',
    'about_admin.add_member': 'Add member',
    'about_admin.add_partner': 'Add partner',
    'about_admin.add_cert': 'Add certificate',
    'services_admin.title': 'Services',
    'admin.panel': 'Admin Panel',
    'admin.dashboard': 'Dashboard',
    'admin.main': 'Main',
    'admin.site': 'Website',
    'admin.settings': 'Settings (Home)',
    'admin.projects': 'Projects',
    'admin.listings_nav': 'Property Listings',
    'admin.services_nav': 'Services',
    'admin.about_nav': 'About Us',
    'admin.contacts_section': 'Contacts & Inquiries',
    'admin.contacts_nav': 'Contacts',
    'admin.inquiries_nav': 'Inquiries',
    'admin.reports_nav': 'Reports',
    'admin.administration': 'Administration',
    'admin.users_nav': 'Users',
    'admin.view_site': 'View Site',
    'admin.language': 'Language',
    // Admin Actions
    'admin.save': 'Save',
    'admin.cancel': 'Cancel',
    'admin.delete': 'Delete',
    'admin.edit': 'Edit',
    'admin.add': 'Add',
    'admin.create': 'Create',
    'admin.search': 'Search...',
    'admin.confirm_delete': 'Are you sure you want to delete?',
    'admin.yes_delete': 'Yes, delete',
    'admin.no_cancel': 'No, cancel',
    'admin.loading': 'Loading...',
    'admin.saving': 'Saving...',
    'admin.success': 'Saved successfully!',
    'admin.error': 'Error. Please try again.',
    'admin.no_data': 'No data',
    'admin.status': 'Status',
    'admin.actions': 'Actions',
    'admin.preview': 'Preview',
    'admin.upload_image': 'Upload Image',
    'admin.drag_reorder': 'Drag to reorder',
    'admin.cover_photo': 'Cover Photo',
    'listings.type_label': 'Listing type',
    'listings.admin_subtitle': 'Manage sale and rent listings',
    'listings.broker_own_only': 'You see only your listings',
    'listings.no_listings': 'No listings',
    'listings.create_first': 'Create the first property listing',
    'listings.contact_name': 'Contact - Name',
    'listings.contact_phone': 'Contact - Phone',
    'listings.contact_email': 'Contact - Email',
    'listings.features_hint': 'Separate with comma: Parking, Elevator, Balcony',
    'listings.all_cities': 'All cities',
    'listings.all_neighborhoods': 'All neighborhoods',
    'listings.in_neighborhood': 'in neighborhood',
    'listings.clear_filters': 'Clear filters',
    'listings.neighborhood_label': 'Neighborhood',
    'listings.neighborhood_hint': 'Neighborhood only — e.g. Lozenets, Iztok',
    'admin.title': 'Title',
    'admin.location': 'Location / City',
    'admin.description': 'Description',
    'admin.name': 'Name',
    'admin.email': 'Email',
    'admin.phone': 'Phone',
    'admin.role': 'Role',
    'admin.price': 'Price',
    'admin.created_at': 'Created at',
    'admin.add_new': 'Add new',
    'admin.upload_images': 'Upload images',
  },

  tr: {
    'properties.all_types': 'Tüm tipler',
    'properties.type_residential': 'Konut',
    'properties.type_commercial': 'Ticari',
    'properties.type_hotel': 'Otel',
    'properties.type_other': 'Diğer',
    'properties.sort_newest': 'En yeni',
    'properties.sort_oldest': 'En eski',
    'properties.load_error': 'Projeler yüklenirken hata oluştu',
    'properties.load_error_hint': 'Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.',
    'properties.refresh': 'Yenile',
    'properties.no_results': 'Proje bulunamadı',
    'properties.no_results_hint': 'Farklı arama kriterleri deneyin',
    'properties.filtered': 'filtrelenmiş',
    'properties.search_placeholder': 'İsim, konum veya açıklamaya göre ara...',
    'properties.category': 'Kategori',
    'properties.of': '/',
    'properties.projects_word': 'proje',
    'property.documents': 'Belgeler',
    'property.follow': 'Projeyi takip edin',
    'property.document': 'Belge',
    'common.gallery': 'Galeri',
    'common.link': 'Bağlantı',
    'map.title': 'Proje konumları',
    'map.project': 'proje',
    'map.projects': 'proje',
    'about.file_unavailable': 'Dosya mevcut değil',
    'seo.home_title': 'Sofya\'da yeni konut projeleri',
    'seo.home_desc': 'GreenCastle — Sofya\'da modern konut kompleksleri. İnşaat halindeki daireler ve uygun fiyatlı tamamlanmış projeler.',
    'seo.home_h1': 'GreenCastle\'dan Sofya\'da yeni konut projeleri ve daireler',
    'seo.about_desc': 'Sofya\'nın önde gelen inşaat geliştiricisi GreenCastle hakkında daha fazla bilgi edinin.',
    'seo.contact_desc': 'Sorularınız ve bilgi için GreenCastle ile iletişime geçin.',
    'seo.listings_desc': 'GreenCastle\'dan satılık ve kiralık emlak ilanları.',
    'seo.properties_desc': 'GreenCastle\'ın Sofya\'daki tüm konut projelerine göz atın.',
    'nav.home': 'Ana Sayfa',
    'nav.services': 'Hizmetler',
    'nav.projects': 'Projeler',
    'nav.listings': 'Emlak',
    'nav.about': 'Hakk\u0131m\u0131zda',
    'nav.contact': '\u0130leti\u015Fim',
    'nav.login': 'Giri\u015F',
    'nav.admin': 'Y\u00F6netim Paneli',
    'nav.logout': '\u00C7\u0131k\u0131\u015F',

    'home.build_dream': 'Hayalinizdeki evi in\u015Fa edin',
    'home.contact_us': 'Bize ula\u015F\u0131n',
    'home.our_services': 'Hizmetlerimiz',
    'home.services_short': '\u0130n\u015Faat alan\u0131nda kapsaml\u0131 hizmetler sunuyoruz',
    'home.view_all_services': 'T\u00FCm hizmetleri g\u00F6r',
    'home.projects_title': 'Projelerimiz',
    'home.projects_subtitle': 'Komplekslerimizden birinde yeni evinizi ke\u015Ffedin',
    'home.view_details': 'Detaylar\u0131 g\u00F6r',
    'home.view_all_projects': 'T\u00FCm projeleri g\u00F6r',
    'home.view_all': 'T\u00FCm\u00FCn\u00FC g\u00F6r',
    'home.project_locations': 'Proje Konumlar\u0131',
    'home.locations_subtitle': 'T\u00FCm projelerimiz Sofya\'da stratejik konumlardad\u0131r',
    'home.partners_title': 'Ortaklar\u0131m\u0131z',
    'home.partners_subtitle': 'Her \u015Firket gibi biz de g\u00FCvenilir ortaklarla \u00E7al\u0131\u015F\u0131yoruz',
    'home.cta_title': 'Yeni evinizi bulmaya haz\u0131r m\u0131s\u0131n\u0131z?',
    'home.cta_subtitle': 'Sorgunuzu iletmek i\u00E7in bizimle ileti\u015Fime ge\u00E7mekten \u00E7ekinmeyin.',
    'home.cta_contact': 'Bize Ula\u015F\u0131n',
    'home.svc_design': 'Tasar\u0131m',
    'home.svc_design_desc': 'Tasar\u0131m deneyimimiz ve en iyi in\u015Faat uygulamalar\u0131 bilgisiyle Green Castle en uygun maliyetli \u00E7\u00F6z\u00FCmleri sunmaktad\u0131r.',
    'home.svc_construction': '\u0130n\u015Faat',
    'home.svc_construction_desc': '\u0130n\u015Faat ve tadilat \u00E7al\u0131\u015Fmalar\u0131n\u0131n her a\u015Famas\u0131nda Avrupa standartlar\u0131na uygun y\u00FCksek kaliteli hizmet garanti ediyoruz.',
    'home.svc_individual': 'Bireysel Yakla\u015F\u0131m',
    'home.svc_individual_desc': 'Green Castle projelerinden size en uygun olan\u0131 se\u00E7me imkan\u0131n\u0131z var.',

    'properties.title': 'Projelerimiz',
    'properties.subtitle': 'GreenCastle\'in t\u00FCm konut komplekslerini ve projelerini inceleyin.',
    'properties.search': '\u0130sim veya konuma g\u00F6re ara...',
    'properties.filter_all': 'T\u00FCm\u00FC',
    'properties.status_active': '\u0130n\u015Faat Halinde',
    'properties.status_upcoming': 'Yak\u0131nda',
    'properties.status_sold': 'Sat\u0131ld\u0131',
    'properties.status_completed': 'Tamamland\u0131',
    'properties.cat_residential': 'Konut',
    'properties.cat_commercial': 'Ticari',
    'properties.cat_hotel': 'Oteller',
    'properties.showing': 'G\u00F6sterilen',
    'properties.of': '/',
    'properties.projects_word': 'proje',
    'properties.no_results': 'Kriterlere uyan proje bulunamad\u0131.',

    'property.back': 'Projelere d\u00F6n',
    'property.overview': 'Genel Bak\u0131\u015F',
    'property.apartments': 'Daireler',
    'property.gallery': 'Galeri',
    'property.location': 'Konum',
    'property.about_project': 'Proje hakk\u0131nda',
    'property.buildings': 'Kompleksteki binalar',
    'property.floors': 'kat',
    'property.select_building': 'Bina se\u00E7in',
    'property.floors_and_apts': 'Katlar ve daireler',
    'property.floor': 'Kat',
    'property.apt': 'Daire',
    'property.area': 'm\u00B2',
    'property.rooms': 'oda',
    'property.available': 'M\u00FCsait',
    'property.reserved': 'Rezerve',
    'property.sold': 'Sat\u0131ld\u0131',
    'property.in_construction': '\u0130n\u015Faat Halinde',
    'property.completed': 'Tamamland\u0131',
    'property.inquiry_btn': 'Bu daire i\u00E7in sorgula',
    'property.send_inquiry': 'Sorgulama G\u00F6nderin',
    'property.not_found': 'Proje bulunamad\u0131',
    'property.no_apartments': 'Bu projeye hen\u00FCz daire eklenmedi.',
    'property.no_photos': 'Bu proje i\u00E7in hen\u00FCz foto\u011Fraf y\u00FCklenmedi.',
    'property.photos_from_admin': 'Foto\u011Fraflar y\u00F6netim panelinden eklenir.',
    'property.project_location': 'Proje konumu',
    'property.photos': 'foto\u011Fraf',
    'property.plan': 'plan',
    'property.blueprint': 'Bina plan\u0131',
    'property.floor_plan': 'Kat Plan\u0131',
    'property.photos_of': 'Foto\u011Fraflar',
    'property.photos_apt': 'Foto\u011Fraflar - Daire',
    'property.features': '\u00D6zellikler',
    'property.number': 'Numara',
    'property.area_label': 'Alan',
    'property.rooms_label': 'Odalar',
    'property.status': 'Durum',
    'property.price': 'Fiyat',
    'property.residential': 'Konut kompleksi',
    'property.apartments_count': 'daire',

    'listings.title': 'Emlak \u0130lanlar\u0131',
    'listings.subtitle': 'Sat\u0131l\u0131k ve kiral\u0131k g\u00FCncel tekliflerimizi inceleyin.',
    'listings.search': 'Ba\u015Fl\u0131k veya konuma g\u00F6re ara...',
    'listings.all': 'T\u00FCm\u00FC',
    'listings.all_categories': 'T\u00FCm kategoriler',
    'listings.sale': 'Sat\u0131l\u0131k',
    'listings.rent': 'Kiral\u0131k',
    'listings.found': 'Bulunan',
    'listings.results': 'ilan',
    'listings.no_results': '\u0130lan bulunamad\u0131',
    'listings.try_filters': 'Farkl\u0131 filtreler deneyin',
    'listings.per_month': '/ay',
    'listings.description': 'A\u00E7\u0131klama',
    'listings.contact': '\u0130leti\u015Fim',
    'listings.call': 'Ara',
    'listings.back': '\u0130lanlara d\u00F6n',
    'listings.not_found': '\u0130lan bulunamad\u0131',
    'listings.price': 'Fiyat',
    'listings.area': 'Alan',
    'listings.rooms_label': 'Odalar',
    'listings.floor_label': 'Kat',
    'listings.year': 'Y\u0131l',
    'listings.gallery': 'Galeri',
    'listings.location': 'Konum',

    'cat.apartment': 'Daire',
    'cat.house': 'Ev',
    'cat.villa': 'Villa',
    'cat.land': 'Arsa',
    'cat.office': 'Ofis',
    'cat.commercial': 'Ticari',
    'cat.garage': 'Garaj',
    'cat.studio': 'St\u00FCdyo',
    'cat.project': 'Proje',

    'services.title': 'Hizmetlerimiz',
    'services.subtitle': '\u0130n\u015Faat ve gayrimenkul alan\u0131nda tam kapsaml\u0131 hizmetler sunuyoruz.',
    'services.hero_subtitle': 'Green CASTLE, bina ara\u015Ft\u0131rma, tasarlama, in\u015Fa ve gayrimenkul ticareti alan\u0131nda faaliyet g\u00F6stermektedir.',
    'services.main_activities': 'Ana Faaliyetler',
    'services.construction_repair': '\u0130n\u015Faat ve Tadilat Hizmetleri',
    'services.construction_repair_sub': 'Deneyimli uzman ekibimize g\u00FCvenin \u2013 ihtiyac\u0131n\u0131z olan tadilat hizmetini sa\u011Flayabilirler.',
    'services.cta_title': 'Ekibimiz t\u00FCm projelerinizi tamamlayacakt\u0131r',
    'services.cta_sub': 'Bize ihtiyac\u0131n\u0131z oldu\u011Funda hizmetinizdeyiz.',
    'services.contact_us': 'Bize Ula\u015F\u0131n',
    'svc.design': 'Mimari Tasar\u0131m',
    'svc.design_desc': 'Tasar\u0131m deneyimimiz ve en iyi in\u015Faat uygulamalar\u0131 bilgisiyle Green Castle en uygun maliyetli \u00E7\u00F6z\u00FCmleri sunmaktad\u0131r.',
    'svc.construction': '\u0130n\u015Faat',
    'svc.construction_desc': '\u0130n\u015Faat ve tadilat \u00E7al\u0131\u015Fmalar\u0131n\u0131n her a\u015Famas\u0131nda Avrupa standartlar\u0131na uygun y\u00FCksek kaliteli hizmet garanti ediyoruz.',
    'svc.residential': 'Konut Binalar\u0131',
    'svc.residential_desc': 'Rahat evinizin tasar\u0131m\u0131 ve in\u015Fas\u0131 i\u00E7in bize g\u00FCvenebilirsiniz.',
    'svc.business': '\u0130\u015F Binalar\u0131 ve Oteller',
    'svc.business_desc': 'Sizin veya i\u015Fletmeniz i\u00E7in en uygun yat\u0131r\u0131m\u0131 birlikte se\u00E7ece\u011Fiz.',
    'svc.masonry': 'Duvar \u00D6rme',
    'svc.masonry_desc': '\u0130n\u015Faatta duvar \u00F6rme, stabilite, dayan\u0131kl\u0131l\u0131k ve gelenek nedeniyle tercih edilmeye devam etmektedir.',
    'svc.plastering': 'Al\u00E7\u0131 S\u0131va',
    'svc.plastering_desc': 'Al\u00E7\u0131 s\u0131va, i\u015Flenmi\u015F y\u00FCzeyde bir bitirme tabakas\u0131 olu\u015Fturan toz veya haz\u0131r bir kar\u0131\u015F\u0131md\u0131r.',
    'svc.painting': 'Boyama',
    'svc.painting_desc': 'Odalar\u0131n boyanmas\u0131nda renk se\u00E7imini \u00E7e\u015Fitli fakt\u00F6rler etkiler.',
    'svc.tiling': 'Fayans D\u00F6\u015Feme',
    'svc.tiling_desc': 'Fayans d\u00F6\u015Feme, tadilatlar\u0131n s\u0131k a\u015Famalar\u0131nda yap\u0131lan bir i\u015Flemdir.',
    'svc.drywall': 'Al\u00E7\u0131pan',
    'svc.drywall_desc': 'Al\u00E7\u0131pan, modern in\u015Faatta devrim yaratan malzemelerden biridir.',
    'svc.insulation': 'Is\u0131 Yal\u0131t\u0131m\u0131',
    'svc.insulation_desc': 'Is\u0131 yal\u0131t\u0131m\u0131 modern in\u015Faat\u0131n temel bir bile\u015Fenidir.',
    'svc.plumbing': 'Tesisat Hizmetleri',
    'svc.plumbing_desc': 'Tesisat hizmetleri \u00E7ok talep g\u00F6rmektedir. Ge\u00E7 olmadan bir uzman bulun.',
    'svc.electrical': 'Elektrik Hizmetleri',
    'svc.electrical_desc': 'Elektrik hizmetleri yeni ev projesi veya tadilat planlamas\u0131yla ba\u015Flar.',
    'svc.demolition': 'Y\u0131k\u0131m ve Nakliye',
    'svc.demolition_desc': '\u015Eerketimiz konteyner veya \u00E7uvallarla depoya y\u0131k\u0131m ve at\u0131k ta\u015F\u0131ma hizmeti sunmaktad\u0131r.',

    'about.title': 'GreenCastle Hakk\u0131nda',
    'about.hero_subtitle': '\u015Eerketimiz tamamen modern, fonksiyonel ve y\u00FCksek kaliteli konut projeleri in\u015Fa etmeye odaklanm\u0131\u015Ft\u0131r.',
    'about.reliable_partner': '\u0130n\u015Faatta g\u00FCvenilir orta\u011F\u0131n\u0131z',
    'about.text1': 'GreenCastle, konut binalar\u0131n\u0131n tasar\u0131m ve in\u015Fas\u0131nda y\u0131llar\u0131n deneyimine sahip bir \u015Firkettir.',
    'about.text2': 'M\u00FC\u015Fterilerimize en y\u00FCksek kalitede in\u015Faat sunmay\u0131 taahh\u00FCt ederiz.',
    'about.text3': 'Misyonumuz, m\u00FC\u015Fterilerimizin beklentilerini a\u015Fan evler in\u015Fa etmektir.',
    'about.years_exp': 'y\u0131l deneyim',
    'about.values_title': 'De\u011Ferlerimiz',
    'about.values_subtitle': 'Bizi i\u015Fimizde y\u00F6nlendiren ilkeler',
    'about.quality': 'Kalite',
    'about.quality_desc': '\u0130n\u015Faat ve tadilat \u00E7al\u0131\u015Fmalar\u0131n\u0131n her a\u015Famas\u0131nda Avrupa standartlar\u0131na uygun y\u00FCksek kaliteli hizmet garanti ediyoruz.',
    'about.precision': 'Hassasiyet',
    'about.precision_desc': 'Tasar\u0131m deneyimimizle en uygun maliyetli \u00E7\u00F6z\u00FCmleri sunuyoruz.',
    'about.customer_care': 'M\u00FC\u015Fteri \u0130lgisi',
    'about.customer_care_desc': 'Her projeye bireysel yakla\u015F\u0131m sunarak m\u00FC\u015Fterilerimizin ihtiya\u00E7 ve zevklerine tam uyum sa\u011Fl\u0131yoruz.',
    'about.reliability': 'G\u00FCvenilirlik',
    'about.reliability_desc': 'Hizmetin zaman\u0131nda tamamlanmas\u0131n\u0131 da garanti ediyoruz. S\u00F6zlerimizi her zaman tutuyoruz.',
    'about.certs_title': 'Sertifikalar ve Belgeler',
    'about.certs_subtitle': 'Ba\u015Far\u0131lar\u0131m\u0131z ve sertifikalar\u0131m\u0131z',
    'about.team_title': 'Ekibimiz',
    'about.team_subtitle': '\u0130n\u015Faat ve mimarl\u0131kta geni\u015F deneyime sahip profesyoneller',
    'about.partners_title': 'Ortaklar\u0131m\u0131z',
    'about.partners_subtitle': 'Sekt\u00F6r\u00FCn \u00F6nde gelen \u015Firketleriyle \u00E7al\u0131\u015F\u0131yoruz',

    'contact.title': 'Bize Ula\u015F\u0131n',
    'contact.subtitle': 'Ekibimiz hizmetinizde.',
    'contact.info_title': '\u0130leti\u015Fim Bilgileri',
    'contact.address': 'Adres',
    'contact.phone': 'Telefon',
    'contact.email': 'E-posta',
    'contact.working_hours': '\u00C7al\u0131\u015Fma Saatleri',
    'contact.hours_value': 'Pzt - Cum: 09:00 - 18:00',
    'contact.sales_dept': 'Sat\u0131\u015F Departman\u0131',
    'contact.find_us': 'Bizi Bulun',
    'contact.form_title': 'Sorgulama G\u00F6nderin',
    'contact.form_subtitle': 'Formu doldurun, en k\u0131sa s\u00FCrede sizinle ileti\u015Fime ge\u00E7elim.',

    'form.name': 'Ad\u0131n\u0131z',
    'form.email': 'E-posta',
    'form.phone': 'Telefon',
    'form.message': 'Mesaj',
    'form.submit': 'Sorgulama G\u00F6nder',
    'form.sending': 'G\u00F6nderiliyor...',
    'form.success_title': 'Te\u015Fekk\u00FCrler!',
    'form.success_msg': 'Sorgunuz ba\u015Far\u0131yla g\u00F6nderildi. En k\u0131sa s\u00FCrede sizinle ileti\u015Fime ge\u00E7ece\u011Fiz.',
    'form.new_inquiry': 'Yeni sorgulama g\u00F6nder',
    'form.inquiry_for': 'Sorgulama:',
    'form.min_length': 'Mesaj en az 10 karakter olmal\u0131d\u0131r.',
    'form.too_many': '\u00C7ok fazla istek. L\u00FCtfen birka\u00E7 dakika bekleyin.',
    'form.error': 'Sorgulama g\u00F6nderilirken hata olu\u015Ftu. L\u00FCtfen tekrar deneyin.',
    'form.placeholder_name': 'Ahmet Y\u0131lmaz',
    'form.placeholder_email': 'ahmet@example.com',
    'form.placeholder_phone': '+90 555 123 4567',
    'form.placeholder_message': 'Hakk\u0131nda daha fazla bilgi almak istiyorum...',

    'login.title': 'Sisteme Giri\u015F',
    'login.subtitle': 'Eri\u015Fim bilgilerinizi girin',
    'login.email': 'E-posta',
    'login.password': '\u015Eifre',
    'login.submit': 'Giri\u015F',
    'login.loading': 'Giri\u015F yap\u0131l\u0131yor...',
    'login.back': 'Siteye d\u00F6n',
    'login.success': 'Ba\u015Far\u0131l\u0131 giri\u015F!',
    'login.error': 'Bir \u015Feyler ters gitti. L\u00FCtfen tekrar deneyin.',

    'footer.description': '\u015Eerketimiz tamamen modern, fonksiyonel ve y\u00FCksek kaliteli konut projeleri in\u015Fa etmeye odaklanm\u0131\u015Ft\u0131r.',
    'footer.quick_links': 'H\u0131zl\u0131 Ba\u011Flant\u0131lar',
    'footer.our_projects': 'Projelerimiz',
    'footer.current_projects': 'G\u00FCncel Projeler',
    'footer.contacts': '\u0130leti\u015Fim',
    'footer.privacy': 'Gizlilik Politikas\u0131',
    'footer.terms': 'Kullan\u0131m Ko\u015Fullar\u0131',
    'footer.rights': 'T\u00FCm haklar\u0131 sakl\u0131d\u0131r.',
    'footer.loading': 'Y\u00FCkleniyor...',
    'footer.sales_dept': 'Sat\u0131\u015F Departman\u0131',

    // Admin Navigation
    // ── Admin Page Translations ──────────────────────────────
    'settings.page_title': 'Site Ayarları',
    'settings.page_subtitle': 'Ana ayarları yönetin',
    'settings.save_all': 'Tüm değişiklikleri kaydet',
    'settings.saved': 'Ayarlar kaydedildi!',
    'settings.save_error': 'Kaydetme hatası',
    'settings.tab.hero': 'Hero Slayt',
    'settings.tab.contact': 'İletişim ve Konum',
    'settings.tab.maps': 'Google Maps',
    'settings.tab.ai': 'AI Entegrasyonu',
    'settings.slideshow.subtitle': 'Slaytlar ana sayfada görünür',
    'settings.slideshow.add_slide': 'Slayt ekle',
    'settings.slideshow.settings': 'Slayt Gösterisi Ayarları',
    'settings.slideshow.speed': 'Hız (saniye)',
    'settings.slideshow.order': 'Gösterim Sırası',
    'settings.slideshow.sequential': 'Sıralı',
    'settings.slideshow.random': 'Rastgele',
    'settings.slideshow.transition': 'Geçiş',
    'settings.slideshow.fade': 'Yumuşak (fade)',
    'settings.slideshow.slide': 'Slayt',
    'settings.slideshow.autoplay': 'Otomatik oynatma',
    'settings.image': 'Görsel',
    'settings.image_url': 'Görsel URL',
    'settings.title_label': 'Başlık',
    'settings.title_placeholder': 'Slayt başlığı',
    'settings.subtitle_label': 'Altyazı / Açıklama',
    'settings.subtitle_placeholder': 'Kısa açıklama',
    'settings.cta_text': 'Buton Metni',
    'settings.cta_link': 'Buton Bağlantısı',
    'settings.no_slides': 'Slayt eklenmedi',
    'settings.add_first_slide': 'İlk slaytı ekle',
    'settings.contact.title': 'İletişim Bilgileri',
    'settings.contact.address': 'Ofis Adresi',
    'settings.contact.phone_office': 'Telefon (ofis)',
    'settings.contact.email_office': 'E-posta (ofis)',
    'settings.contact.phone_sales': 'Telefon (satış)',
    'settings.contact.email_sales': 'E-posta (satış)',
    'settings.contact.extra_phone_1': 'Ek telefon 1',
    'settings.contact.extra_email_1': 'Ek e-posta 1',
    'settings.contact.extra_phone_2': 'Ek telefon 2',
    'settings.contact.extra_email_2': 'Ek e-posta 2',
    'settings.contact.optional': 'Gerekmiyorsa boş bırakın',
    'settings.contact.extra_socials': 'Ek sosyal ağlar',
    'settings.contact.add_network': 'Ağ ekle',
    'settings.location.title': 'Ofis Konumu',
    'settings.location.subtitle': 'Koordinatlar harita konumunu belirler',
    'settings.location.lat': 'Enlem',
    'settings.location.lng': 'Boylam',
    'settings.location.map_preview': 'Harita Önizlemesi',
    'settings.maps.title': 'Google Maps API Anahtarı',
    'settings.maps.api_key_label': 'API Anahtarı',
    'settings.ai.section_title': 'AI Entegrasyonu',
    'settings.tracking.title': 'Takip & Analiz',
    'props.page_title': 'Mülk Yönetimi',
    'props.page_subtitle': 'Projeler, binalar, katlar ve daireler',
    'props.new_project': 'Yeni Proje',
    'props.edit_project': 'Projeyi Düzenle',
    'props.add_building': 'Bina',
    'props.category': 'Kategori',
    'props.status.active': 'İnşaat Halinde',
    'props.status.upcoming': 'Yakında',
    'props.status.completed': 'Tamamlandı',
    'props.cat.residential': 'Konut',
    'props.cat.commercial': 'Ticari',
    'props.cat.hotel': 'Otel',
    'props.images_hint': '1. = Logo · 2. = Kapak · sürükle',
    'props.documents': 'Belgeler',
    'props.social_networks': 'Sosyal Ağlar',
    'props.uploading': 'Yükleniyor...',
    'props.create': 'Oluştur',
    'props.edit_building': 'Binayı Düzenle',
    'props.new_building': 'Yeni Bina',
    'props.edit_floor': 'Katı Düzenle',
    'props.new_floor': 'Yeni Kat',
    'props.edit_apt': 'Daireyi Düzenle',
    'props.new_apt': 'Yeni Daire',
    'props.apt.available': 'Müsait',
    'props.apt.reserved': 'Rezerve',
    'props.apt.sold': 'Satıldı',
    'props.floor_number': 'Kat numarası',
    'props.floor_description': 'Kat açıklaması',
    'props.floor_photos': 'Ortak alan fotoğrafları',
    'props.apt_number': 'Numara',
    'dashboard.morning': 'Günaydın',
    'dashboard.afternoon': 'İyi günler',
    'dashboard.evening': 'İyi akşamlar',
    'dashboard.welcome': 'Hoş geldiniz',
    'dashboard.manage_listings': 'İlanlarınızı yönetin',
    'about_admin.page_title': 'Hakkımızda Sayfası',
    'about_admin.page_subtitle': 'Sayfa içeriğini yönetin',
    'about_admin.description': 'Açıklama',
    'about_admin.company_text': 'Şirket metni',
    'about_admin.our_team': 'Ekibimiz',
    'about_admin.certifications': 'Sertifikalar',
    'inquiries.page_subtitle': 'Sorguları görüntüle',
    'inquiries.activate_notifs': 'E-posta bildirimlerini etkinleştir',
    'inquiries.no_recipients': 'Alıcı eklenmedi',
    'inquiries.send_test_email': 'Test e-postası gönder',
    'services_admin.subtitle': 'Hizmetleri yönetin',
    'services_admin.icon': 'İkon',
    'reports.title': 'Raporlar ve Kayıtlar',
    'reports.no_reports': 'Rapor oluşturulmadı',
    'reports.view_report': 'Raporu görüntüle',
    'reports.period': 'Dönem verileri',
    'reports.format': 'Biçim',
    'common.close': 'Kapat',
    'common.cancel': 'İptal',
    'common.save': 'Kaydet',
    'common.add': 'Ekle',
    'common.delete': 'Sil',
    'common.edit': 'Düzenle',
    'common.loading': 'Yükleniyor...',
    'common.no_data': 'Veri yok',
    'dashboard.last_6months': 'son 6 ay',
    'dashboard.inquiries_by_month': 'Aylık Sorgular',
    'dashboard.by_status': 'Duruma Göre Dağılım',
    'dashboard.latest_inquiries': 'Son Sorgular',
    'dashboard.quick_actions': 'Hızlı İşlemler',
    'listings.admin_title': 'Emlak İlanları',
    'listings.new_listing': 'Yeni İlan',
    'listings.edit_listing': 'İlanı Düzenle',
    'listings.area_label': 'Alan',
    'listings.rooms_label': 'Odalar',
    'listings.floor_label': 'Kat',
    'listings.year_label': 'Yıl',
    'listings.features': 'Özellikler',
    'listings.sale_or_rent': 'Satış veya Kiralık',
    'inquiries.title': 'Sorgular',
    'inquiries.email_notifs': 'E-posta Bildirimleri',
    'inquiries.all': 'Tümü',
    'inquiries.new': 'Yeni',
    'inquiries.read': 'Okunmuş',
    'inquiries.replied': 'Yanıtlandı',
    'inquiries.send_test': 'Test gönder',
    'inquiries.save_settings': 'Ayarları kaydet',
    'inquiries.recipients': 'Bildirim alıcıları',
    'inquiries.smtp_settings': 'SMTP Ayarları',
    'inquiries.smtp_server': 'SMTP Sunucusu',
    'inquiries.smtp_port': 'Port',
    'inquiries.smtp_user': 'Kullanıcı',
    'inquiries.smtp_password': 'Şifre',
    'props.project_name': 'Proje Adı',
    'props.building_name': 'Bina Adı',
    'props.floors_count': 'Kat sayısı',
    'props.blueprint': 'Plan / Çizim',
    'props.building_photos': 'Bina fotoğrafları',
    'props.apts_count': 'Daire sayısı',
    'props.upload_btn': 'Yükle',
    'props.upload_blueprint': 'Plan yükle',
    'inquiries.sender_name': 'Gönderici adı',
    'inquiries.use_tls': 'TLS/SSL kullan',
    'dashboard.apartments': 'Daireler',
    'inquiries.smtp_sender': 'Gönderici',
    'inquiries.no_inquiries': 'Sorgu yok',
    'inquiries.status.new': 'Yeni',
    'inquiries.status.read': 'Okunmuş',
    'inquiries.status.replied': 'Yanıtlandı',
    'users.title': 'Kullanıcılar',
    'users.new_user': 'Yeni Kullanıcı',
    'users.edit_user': 'Kullanıcıyı Düzenle',
    'users.system_account': 'Sistem Hesabı',
    'users.change_password': 'Şifre Değiştir',
    'users.role.admin': 'Yönetici',
    'users.role.manager': 'Müdür',
    'users.role.editor': 'Editör',
    'users.role.broker': 'Acente',
    'dashboard.residential_complexes': 'konut kompleksleri',
    'dashboard.in_all_projects': 'tüm projelerde',
    'listings.neighborhood_label': 'Mahalle',
    'listings.neighborhood_hint': 'Sadece mahalle',
    'listings.all_neighborhoods': 'Tüm mahalleler',
    'listings.in_neighborhood': 'mahallede',
    'listings.clear_filters': 'Filtreleri temizle',
    'dashboard.sale_and_rent': 'satış ve kiralık',
    'dashboard.from_clients': 'müşterilerden',
    'about_admin.title': 'Hakkımızda',
    'about_admin.team': 'Ekip',
    'about_admin.partners': 'Ortaklar',
    'about_admin.certificates': 'Sertifikalar',
    'about_admin.add_member': 'Üye ekle',
    'about_admin.add_partner': 'Ortak ekle',
    'about_admin.add_cert': 'Sertifika ekle',
    'services_admin.title': 'Hizmetler',
    'admin.panel': 'Y\u00F6netim Paneli',
    'admin.dashboard': 'Kontrol Paneli',
    'admin.main': 'Ana',
    'admin.site': 'Site',
    'admin.settings': 'Ayarlar (Ana Sayfa)',
    'admin.projects': 'Projeler',
    'admin.listings_nav': 'Emlak \u0130lanlar\u0131',
    'admin.services_nav': 'Hizmetler',
    'admin.about_nav': 'Hakk\u0131m\u0131zda',
    'admin.contacts_section': '\u0130leti\u015Fim ve Sorgular',
    'admin.contacts_nav': '\u0130leti\u015Fim',
    'admin.inquiries_nav': 'Sorgular',
    'admin.reports_nav': 'Raporlar',
    'admin.administration': 'Y\u00F6netim',
    'admin.users_nav': 'Kullan\u0131c\u0131lar',
    'admin.view_site': 'Siteyi G\u00F6r',
    'admin.language': 'Dil',
    'admin.save': 'Kaydet',
    'admin.cancel': '\u0130ptal',
    'admin.delete': 'Sil',
    'admin.edit': 'D\u00FCzenle',
    'admin.add': 'Ekle',
    'admin.create': 'Olu\u015Ftur',
    'admin.search': 'Ara...',
    'admin.confirm_delete': 'Silmek istedi\u011Finizden emin misiniz?',
    'admin.yes_delete': 'Evet, sil',
    'admin.no_cancel': 'Hay\u0131r, iptal',
    'admin.loading': 'Y\u00FCkleniyor...',
    'admin.saving': 'Kaydediliyor...',
    'admin.success': 'Ba\u015Far\u0131yla kaydedildi!',
    'admin.error': 'Hata. L\u00FCtfen tekrar deneyin.',
    'admin.no_data': 'Veri yok',
    'admin.status': 'Durum',
    'admin.actions': 'Eylemler',
    'admin.preview': '\u00D6nizleme',
    'admin.upload_image': 'G\u00F6rsel Y\u00FCkle',
    'admin.drag_reorder': 'Yeniden s\u0131ralamak i\u00E7in s\u00FCr\u00FCkleyin',
    'admin.cover_photo': 'Kapak Foto\u011Fraf\u0131',
    'listings.type_label': 'İlan tipi',
    'listings.admin_subtitle': 'Satış ve kiralık ilanları yönetin',
    'listings.broker_own_only': 'Yalnızca kendi ilanlarınızı görüyorsunuz',
    'listings.no_listings': 'İlan yok',
    'listings.create_first': 'İlk ilanı oluşturun',
    'listings.contact_name': 'İletişim - Ad',
    'listings.contact_phone': 'İletişim - Telefon',
    'listings.contact_email': 'İletişim - E-posta',
    'listings.features_hint': 'Virgülle ayırın',
    'listings.all_cities': 'Tüm şehirler',
    'listings.all_neighborhoods': 'Tüm mahalleler',
    'listings.in_neighborhood': 'mahallede',
    'listings.clear_filters': 'Filtreleri temizle',
    'listings.neighborhood_label': 'Mahalle',
    'listings.neighborhood_hint': 'Sadece mahalle',
    'admin.title': 'Başlık',
    'admin.location': 'Konum / Şehir',
    'admin.description': 'Açıklama',
    'admin.name': 'Ad',
    'admin.email': 'E-posta',
    'admin.phone': 'Telefon',
    'admin.role': 'Rol',
    'admin.price': 'Fiyat',
    'admin.created_at': 'Oluşturulma',
    'admin.add_new': 'Yeni ekle',
    'admin.upload_images': 'Resimler yükle',
  },

  el: {
    'properties.all_types': 'Όλοι οι τύποι',
    'properties.type_residential': 'Οικιστικό',
    'properties.type_commercial': 'Επαγγελματικό',
    'properties.type_hotel': 'Ξενοδοχείο',
    'properties.type_other': 'Άλλα',
    'properties.sort_newest': 'Νεότερα',
    'properties.sort_oldest': 'Παλαιότερα',
    'properties.load_error': 'Σφάλμα φόρτωσης έργων',
    'properties.load_error_hint': 'Παρακαλώ ανανεώστε τη σελίδα ή δοκιμάστε ξανά αργότερα.',
    'properties.refresh': 'Ανανέωση',
    'properties.no_results': 'Δεν βρέθηκαν έργα',
    'properties.no_results_hint': 'Δοκιμάστε διαφορετικά κριτήρια αναζήτησης',
    'properties.filtered': 'φιλτραρισμένο',
    'properties.search_placeholder': 'Αναζήτηση με όνομα, τοποθεσία, περιγραφή...',
    'properties.category': 'Κατηγορία',
    'properties.of': 'από',
    'properties.projects_word': 'έργα',
    'property.documents': 'Έγγραφα',
    'property.follow': 'Ακολουθήστε το έργο',
    'property.document': 'Έγγραφο',
    'common.gallery': 'Γκαλερί',
    'common.link': 'Σύνδεσμος',
    'map.title': 'Τοποθεσίες έργων',
    'map.project': 'έργο',
    'map.projects': 'έργα',
    'about.file_unavailable': 'Το αρχείο δεν είναι διαθέσιμο',
    'seo.home_title': 'Νέα οικιστικά έργα στη Σόφια',
    'seo.home_desc': 'GreenCastle — μοντέρνα οικιστικά συγκροτήματα στη Σόφια. Διαμερίσματα υπό κατασκευή και ολοκληρωμένα έργα σε προσιτές τιμές.',
    'seo.home_h1': 'Νέα οικιστικά έργα και διαμερίσματα στη Σόφια από την GreenCastle',
    'seo.about_desc': 'Μάθετε περισσότερα για την GreenCastle — κορυφαίο κατασκευαστή στη Σόφια.',
    'seo.contact_desc': 'Επικοινωνήστε με την GreenCastle για ερωτήσεις και πληροφορίες.',
    'seo.listings_desc': 'Αγγελίες πώλησης και ενοικίασης ακινήτων από την GreenCastle.',
    'seo.properties_desc': 'Περιηγηθείτε σε όλα τα οικιστικά έργα της GreenCastle στη Σόφια.',
    // Nav
    'nav.home': '\u0391\u03C1\u03C7\u03B9\u03BA\u03AE',
    'nav.services': '\u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2',
    'nav.projects': '\u0388\u03C1\u03B3\u03B1',
    'nav.listings': '\u0391\u03BA\u03AF\u03BD\u03B7\u03C4\u03B1',
    'nav.about': '\u03A3\u03C7\u03B5\u03C4\u03B9\u03BA\u03AC \u03BC\u03B5 \u03B5\u03BC\u03AC\u03C2',
    'nav.contact': '\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1',
    'nav.login': '\u0395\u03AF\u03C3\u03BF\u03B4\u03BF\u03C2',
    'nav.admin': '\u03A0\u03AF\u03BD\u03B1\u03BA\u03B1\u03C2 \u03B4\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7\u03C2',
    'nav.logout': '\u0388\u03BE\u03BF\u03B4\u03BF\u03C2',

    // Home
    'home.build_dream': '\u03A7\u03C4\u03AF\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C3\u03C0\u03AF\u03C4\u03B9 \u03C4\u03C9\u03BD \u03BF\u03BD\u03B5\u03AF\u03C1\u03C9\u03BD \u03C3\u03B1\u03C2',
    'home.contact_us': '\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2',
    'home.our_services': '\u039F\u03B9 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u03BC\u03B1\u03C2',
    'home.services_short': '\u03A0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03BF\u03C5\u03BC\u03B5 \u03C0\u03BB\u03AE\u03C1\u03B5\u03C2 \u03C6\u03AC\u03C3\u03BC\u03B1 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03B9\u03CE\u03BD \u03C3\u03C4\u03BF\u03BD \u03C4\u03BF\u03BC\u03AD\u03B1 \u03C4\u03B7\u03C2 \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE\u03C2',
    'home.view_all_services': '\u0394\u03B5\u03AF\u03C4\u03B5 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2',
    'home.projects_title': '\u03A4\u03B1 \u0388\u03C1\u03B3\u03B1 \u03BC\u03B1\u03C2',
    'home.projects_subtitle': '\u0391\u03BD\u03B1\u03BA\u03B1\u03BB\u03CD\u03C8\u03C4\u03B5 \u03C4\u03BF \u03BD\u03AD\u03BF \u03C3\u03B1\u03C2 \u03C3\u03C0\u03AF\u03C4\u03B9 \u03C3\u03B5 \u03AD\u03BD\u03B1\u03BD \u03B1\u03C0\u03CC \u03C4\u03BF\u03C5\u03C2 \u03C3\u03C5\u03B3\u03BA\u03C1\u03BF\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03BC\u03B1\u03C2',
    'home.view_details': '\u0394\u03B5\u03AF\u03C4\u03B5 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2',
    'home.view_all_projects': '\u0394\u03B5\u03AF\u03C4\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03AD\u03C1\u03B3\u03B1',
    'home.view_all': '\u0394\u03B5\u03AF\u03C4\u03B5 \u03CC\u03BB\u03B1',
    'home.project_locations': '\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2 \u0388\u03C1\u03B3\u03C9\u03BD',
    'home.locations_subtitle': '\u038C\u03BB\u03B1 \u03C4\u03B1 \u03AD\u03C1\u03B3\u03B1 \u03BC\u03B1\u03C2 \u03B2\u03C1\u03AF\u03C3\u03BA\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C3\u03B5 \u03C3\u03C4\u03C1\u03B1\u03C4\u03B7\u03B3\u03B9\u03BA\u03AD\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03C3\u03C4\u03B7 \u03A3\u03CC\u03C6\u03B9\u03B1',
    'home.partners_title': '\u039F\u03B9 \u03A3\u03C5\u03BD\u03B5\u03C1\u03B3\u03AC\u03C4\u03B5\u03C2 \u03BC\u03B1\u03C2',
    'home.partners_subtitle': '\u038C\u03C0\u03C9\u03C2 \u03BA\u03AC\u03B8\u03B5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1, \u03AD\u03C7\u03BF\u03C5\u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03B1\u03BE\u03B9\u03CC\u03C0\u03B9\u03C3\u03C4\u03BF\u03C5\u03C2 \u03C3\u03C5\u03BD\u03B5\u03C1\u03B3\u03AC\u03C4\u03B5\u03C2 \u03BC\u03B1\u03C2',
    'home.cta_title': '\u0395\u03AF\u03C3\u03C4\u03B5 \u03AD\u03C4\u03BF\u03B9\u03BC\u03BF\u03B9 \u03BD\u03B1 \u03B2\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF \u03BD\u03AD\u03BF \u03C3\u03B1\u03C2 \u03C3\u03C0\u03AF\u03C4\u03B9;',
    'home.cta_subtitle': '\u039C\u03B7\u03BD \u03B4\u03B9\u03C3\u03C4\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2 \u03B1\u03BC\u03AD\u03C3\u03C9\u03C2.',
    'home.cta_contact': '\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2',
    'home.svc_design': '\u03A3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2',
    'home.svc_design_desc': '\u039C\u03B5 \u03C4\u03B7\u03BD \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03C3\u03C4\u03BF\u03BD \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03CC, \u03C0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03BF\u03C5\u03BC\u03B5 \u03BF\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03AC \u03BB\u03CD\u03C3\u03B5\u03B9\u03C2.',
    'home.svc_construction': '\u039A\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE',
    'home.svc_construction_desc': '\u03A3\u03B5 \u03BA\u03AC\u03B8\u03B5 \u03C3\u03C4\u03AC\u03B4\u03B9\u03BF \u03C4\u03C9\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03B9\u03CE\u03BD, \u03B5\u03B3\u03B3\u03C5\u03AC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C5\u03C8\u03B7\u03BB\u03AE \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03CD\u03BC\u03C6\u03C9\u03BD\u03B1 \u03BC\u03B5 \u03C4\u03B1 \u03B5\u03C5\u03C1\u03C9\u03C0\u03B1\u03CA\u03BA\u03AC \u03C0\u03C1\u03CC\u03C4\u03C5\u03C0\u03B1.',
    'home.svc_individual': '\u0391\u03C4\u03BF\u03BC\u03B9\u03BA\u03AE \u03A0\u03C1\u03BF\u03C3\u03AD\u03B3\u03B3\u03B9\u03C3\u03B7',
    'home.svc_individual_desc': '\u0388\u03C7\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03C4\u03BF \u03BA\u03B1\u03C4\u03B1\u03BB\u03BB\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03BF \u03AD\u03C1\u03B3\u03BF \u03C0\u03BF\u03C5 \u03B1\u03BD\u03C4\u03B1\u03C0\u03BF\u03BA\u03C1\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B9\u03C2 \u03B1\u03BD\u03AC\u03B3\u03BA\u03B5\u03C2 \u03C3\u03B1\u03C2.',

    // Properties
    'properties.title': '\u03A4\u03B1 \u0388\u03C1\u03B3\u03B1 \u03BC\u03B1\u03C2',
    'properties.subtitle': '\u03A0\u03B5\u03C1\u03B9\u03B7\u03B3\u03B7\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03BF\u03B9\u03BA\u03B9\u03C3\u03C4\u03B9\u03BA\u03AC \u03C3\u03C5\u03B3\u03BA\u03C1\u03BF\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03AD\u03C1\u03B3\u03B1 \u03C4\u03B7\u03C2 GreenCastle.',
    'properties.search': '\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03BC\u03B5 \u03CC\u03BD\u03BF\u03BC\u03B1 \u03AE \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1...',
    'properties.filter_all': '\u038C\u03BB\u03B1',
    'properties.status_active': '\u03A5\u03C0\u03CC \u039A\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE',
    'properties.status_upcoming': '\u03A0\u03C1\u03BF\u03C3\u03B5\u03C7\u03CC\u03BC\u03B5\u03BD\u03B1',
    'properties.status_sold': '\u03A0\u03BF\u03C5\u03BB\u03AE\u03B8\u03B7\u03BA\u03B1\u03BD',
    'properties.status_completed': '\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03BD\u03B1',
    'properties.cat_residential': '\u039F\u03B9\u03BA\u03B9\u03C3\u03C4\u03B9\u03BA\u03AC',
    'properties.cat_commercial': '\u0395\u03BC\u03C0\u03BF\u03C1\u03B9\u03BA\u03AC',
    'properties.cat_hotel': '\u039E\u03B5\u03BD\u03BF\u03B4\u03BF\u03C7\u03B5\u03AF\u03B1',
    'properties.showing': '\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7',
    'properties.of': '\u03B1\u03C0\u03CC',
    'properties.projects_word': '\u03AD\u03C1\u03B3\u03B1',
    'properties.no_results': '\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03AD\u03C1\u03B3\u03B1 \u03BC\u03B5 \u03B1\u03C5\u03C4\u03AC \u03C4\u03B1 \u03BA\u03C1\u03B9\u03C4\u03AE\u03C1\u03B9\u03B1.',

    // Property Detail
    'property.back': '\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B1 \u03AD\u03C1\u03B3\u03B1',
    'property.overview': '\u0393\u03B5\u03BD\u03B9\u03BA\u03AE \u0395\u03C0\u03B9\u03C3\u03BA\u03CC\u03C0\u03B7\u03C3\u03B7',
    'property.apartments': '\u0394\u03B9\u03B1\u03BC\u03B5\u03C1\u03AF\u03C3\u03BC\u03B1\u03C4\u03B1',
    'property.gallery': '\u0393\u03BA\u03B1\u03BB\u03B5\u03C1\u03AF',
    'property.location': '\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1',
    'property.about_project': '\u03A3\u03C7\u03B5\u03C4\u03B9\u03BA\u03AC \u03BC\u03B5 \u03C4\u03BF \u03AD\u03C1\u03B3\u03BF',
    'property.buildings': '\u039A\u03C4\u03AF\u03C1\u03B9\u03B1 \u03C3\u03C4\u03BF \u03C3\u03C5\u03B3\u03BA\u03C1\u03CC\u03C4\u03B7\u03BC\u03B1',
    'property.floors': '\u03CC\u03C1\u03BF\u03C6\u03BF\u03B9',
    'property.select_building': '\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BA\u03C4\u03AF\u03C1\u03B9\u03BF',
    'property.floors_and_apts': '\u038C\u03C1\u03BF\u03C6\u03BF\u03B9 \u03BA\u03B1\u03B9 \u03B4\u03B9\u03B1\u03BC\u03B5\u03C1\u03AF\u03C3\u03BC\u03B1\u03C4\u03B1',
    'property.floor': '\u038C\u03C1\u03BF\u03C6\u03BF\u03C2',
    'property.apt': '\u0394\u03B9\u03B1\u03BC.',
    'property.area': '\u03C4.\u03BC.',
    'property.rooms': '\u03B4\u03C9\u03BC\u03AC\u03C4\u03B9\u03B1',
    'property.available': '\u0394\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF',
    'property.reserved': '\u0394\u03B5\u03C3\u03BC\u03B5\u03C5\u03BC\u03AD\u03BD\u03BF',
    'property.sold': '\u03A0\u03BF\u03C5\u03BB\u03AE\u03B8\u03B7\u03BA\u03B5',
    'property.in_construction': '\u03A5\u03C0\u03CC \u039A\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE',
    'property.completed': '\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5',
    'property.inquiry_btn': '\u0395\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03B4\u03B9\u03B1\u03BC\u03AD\u03C1\u03B9\u03C3\u03BC\u03B1',
    'property.send_inquiry': '\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u0395\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7\u03C2',
    'property.not_found': '\u03A4\u03BF \u03AD\u03C1\u03B3\u03BF \u03B4\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5',
    'property.no_apartments': '\u0394\u03B5\u03BD \u03AD\u03C7\u03BF\u03C5\u03BD \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03B5\u03AF \u03B4\u03B9\u03B1\u03BC\u03B5\u03C1\u03AF\u03C3\u03BC\u03B1\u03C4\u03B1 \u03B1\u03BA\u03CC\u03BC\u03B7.',
    'property.no_photos': '\u0394\u03B5\u03BD \u03AD\u03C7\u03BF\u03C5\u03BD \u03B1\u03BD\u03B5\u03B2\u03B1\u03C3\u03C4\u03B5\u03AF \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B5\u03C2 \u03B1\u03BA\u03CC\u03BC\u03B7.',
    'property.photos_from_admin': '\u039F\u03B9 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B5\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C4\u03AF\u03B8\u03B5\u03BD\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03C0\u03AF\u03BD\u03B1\u03BA\u03B1 \u03B4\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7\u03C2.',
    'property.project_location': '\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03AD\u03C1\u03B3\u03BF\u03C5',
    'property.photos': '\u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B5\u03C2',
    'property.plan': '\u03BA\u03AC\u03C4\u03BF\u03C8\u03B7',
    'property.blueprint': '\u03A3\u03C7\u03AD\u03B4\u03B9\u03BF \u03BA\u03C4\u03B9\u03C1\u03AF\u03BF\u03C5',
    'property.floor_plan': '\u039A\u03AC\u03C4\u03BF\u03C8\u03B7 \u039F\u03C1\u03CC\u03C6\u03BF\u03C5',
    'property.photos_of': '\u03A6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B5\u03C2 \u03C4\u03BF\u03C5',
    'property.photos_apt': '\u03A6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B5\u03C2 - \u0394\u03B9\u03B1\u03BC.',
    'property.features': '\u03A7\u03B1\u03C1\u03B1\u03BA\u03C4\u03B7\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03AC',
    'property.number': '\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2',
    'property.area_label': '\u0395\u03BC\u03B2\u03B1\u03B4\u03CC\u03BD',
    'property.rooms_label': '\u0394\u03C9\u03BC\u03AC\u03C4\u03B9\u03B1',
    'property.status': '\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7',
    'property.price': '\u03A4\u03B9\u03BC\u03AE',
    'property.residential': '\u039F\u03B9\u03BA\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03C3\u03C5\u03B3\u03BA\u03C1\u03CC\u03C4\u03B7\u03BC\u03B1',
    'property.apartments_count': '\u03B4\u03B9\u03B1\u03BC\u03B5\u03C1\u03AF\u03C3\u03BC\u03B1\u03C4\u03B1',

    // Listings
    'listings.title': '\u0391\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2 \u0391\u03BA\u03B9\u03BD\u03AE\u03C4\u03C9\u03BD',
    'listings.subtitle': '\u03A0\u03B5\u03C1\u03B9\u03B7\u03B3\u03B7\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B5\u03BD\u03B5\u03C1\u03B3\u03AD\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2 \u03C0\u03CE\u03BB\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03B5\u03BD\u03BF\u03B9\u03BA\u03AF\u03B1\u03C3\u03B7\u03C2.',
    'listings.search': '\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03BC\u03B5 \u03C4\u03AF\u03C4\u03BB\u03BF \u03AE \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1...',
    'listings.all': '\u038C\u03BB\u03B5\u03C2',
    'listings.all_categories': '\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B5\u03C2',
    'listings.sale': '\u03A0\u03C1\u03BF\u03C2 \u03A0\u03CE\u03BB\u03B7\u03C3\u03B7',
    'listings.rent': '\u0395\u03BD\u03BF\u03B9\u03BA\u03AF\u03B1\u03C3\u03B7',
    'listings.found': '\u0392\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD',
    'listings.results': '\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2',
    'listings.no_results': '\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2',
    'listings.try_filters': '\u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AC \u03C6\u03AF\u03BB\u03C4\u03C1\u03B1',
    'listings.per_month': '/\u03BC\u03AE\u03BD\u03B1',
    'listings.description': '\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE',
    'listings.contact': '\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1',
    'listings.call': '\u039A\u03BB\u03AE\u03C3\u03B7',
    'listings.back': '\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B9\u03C2 \u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2',
    'listings.not_found': '\u0397 \u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03B4\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5',
    'listings.price': '\u03A4\u03B9\u03BC\u03AE',
    'listings.area': '\u0395\u03BC\u03B2\u03B1\u03B4\u03CC\u03BD',
    'listings.rooms_label': '\u0394\u03C9\u03BC\u03AC\u03C4\u03B9\u03B1',
    'listings.floor_label': '\u038C\u03C1\u03BF\u03C6\u03BF\u03C2',
    'listings.year': '\u0388\u03C4\u03BF\u03C2',
    'listings.gallery': '\u0393\u03BA\u03B1\u03BB\u03B5\u03C1\u03AF',
    'listings.location': '\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1',

    // Categories
    'cat.apartment': '\u0394\u03B9\u03B1\u03BC\u03AD\u03C1\u03B9\u03C3\u03BC\u03B1',
    'cat.house': '\u039A\u03B1\u03C4\u03BF\u03B9\u03BA\u03AF\u03B1',
    'cat.villa': '\u0392\u03AF\u03BB\u03B1',
    'cat.land': '\u039F\u03B9\u03BA\u03CC\u03C0\u03B5\u03B4\u03BF',
    'cat.office': '\u0393\u03C1\u03B1\u03C6\u03B5\u03AF\u03BF',
    'cat.commercial': '\u0395\u03BC\u03C0\u03BF\u03C1\u03B9\u03BA\u03CC\u03C2 \u03C7\u03CE\u03C1\u03BF\u03C2',
    'cat.garage': '\u0393\u03BA\u03B1\u03C1\u03AC\u03B6',
    'cat.studio': '\u03A3\u03C4\u03BF\u03CD\u03BD\u03C4\u03B9\u03BF',
    'cat.project': '\u0388\u03C1\u03B3\u03BF',

    // Services
    'services.title': '\u039F\u03B9 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u03BC\u03B1\u03C2',
    'services.subtitle': '\u03A0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03BF\u03C5\u03BC\u03B5 \u03C0\u03BB\u03AE\u03C1\u03B5\u03C2 \u03C6\u03AC\u03C3\u03BC\u03B1 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03B9\u03CE\u03BD \u03C3\u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE \u03BA\u03B1\u03B9 \u03C4\u03B1 \u03B1\u03BA\u03AF\u03BD\u03B7\u03C4\u03B1.',
    'services.hero_subtitle': '\u0397 Green CASTLE \u03B4\u03C1\u03B1\u03C3\u03C4\u03B7\u03C1\u03B9\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF\u03C4\u03B1\u03B9 \u03C3\u03C4\u03BF\u03BD \u03C4\u03BF\u03BC\u03AD\u03B1 \u03B5\u03C1\u03B5\u03C5\u03BD\u03CE\u03BD, \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD, \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE\u03C2 \u03BA\u03C4\u03B9\u03C1\u03AF\u03C9\u03BD \u03BA\u03B1\u03B9 \u03B5\u03BC\u03C0\u03BF\u03C1\u03AF\u03B1\u03C2 \u03B1\u03BA\u03B9\u03BD\u03AE\u03C4\u03C9\u03BD.',
    'services.main_activities': '\u039A\u03CD\u03C1\u03B9\u03B5\u03C2 \u0394\u03C1\u03B1\u03C3\u03C4\u03B7\u03C1\u03B9\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2',
    'services.construction_repair': '\u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u039A\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE\u03C2 & \u0391\u03BD\u03B1\u03BA\u03B1\u03AF\u03BD\u03B9\u03C3\u03B7\u03C2',
    'services.construction_repair_sub': '\u0395\u03BC\u03C0\u03B9\u03C3\u03C4\u03B5\u03C5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03B7\u03BD \u03BF\u03BC\u03AC\u03B4\u03B1 \u03BC\u03B1\u03C2 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03BF\u03B3\u03BD\u03C9\u03BC\u03CC\u03BD\u03C9\u03BD \u03B5\u03B9\u03B4\u03B9\u03BA\u03CE\u03BD.',
    'services.cta_title': '\u0397 \u03BF\u03BC\u03AC\u03B4\u03B1 \u03BC\u03B1\u03C2 \u03B8\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03B9 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03AD\u03C1\u03B3\u03B1 \u03C3\u03B1\u03C2',
    'services.cta_sub': '\u0395\u03AF\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C3\u03C4\u03B7 \u03B4\u03B9\u03AC\u03B8\u03B5\u03C3\u03AE \u03C3\u03B1\u03C2 \u03CC\u03C4\u03B1\u03BD \u03BC\u03B1\u03C2 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5.',
    'services.contact_us': '\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2',
    'svc.design': '\u0391\u03C1\u03C7\u03B9\u03C4\u03B5\u03BA\u03C4\u03BF\u03BD\u03B9\u03BA\u03CC\u03C2 \u03A3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2',
    'svc.design_desc': '\u039C\u03B5 \u03C4\u03B7\u03BD \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03C3\u03C4\u03BF\u03BD \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03CC, \u03C0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03BF\u03C5\u03BC\u03B5 \u03BF\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03AC \u03BB\u03CD\u03C3\u03B5\u03B9\u03C2.',
    'svc.construction': '\u039A\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE',
    'svc.construction_desc': '\u03A3\u03B5 \u03BA\u03AC\u03B8\u03B5 \u03C3\u03C4\u03AC\u03B4\u03B9\u03BF, \u03B5\u03B3\u03B3\u03C5\u03AC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C5\u03C8\u03B7\u03BB\u03AE \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03CD\u03BC\u03C6\u03C9\u03BD\u03B1 \u03BC\u03B5 \u03B5\u03C5\u03C1\u03C9\u03C0\u03B1\u03CA\u03BA\u03AC \u03C0\u03C1\u03CC\u03C4\u03C5\u03C0\u03B1.',
    'svc.residential': '\u039F\u03B9\u03BA\u03B9\u03C3\u03C4\u03B9\u03BA\u03AC \u039A\u03C4\u03AF\u03C1\u03B9\u03B1',
    'svc.residential_desc': '\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03BC\u03B1\u03C2 \u03B5\u03BC\u03C0\u03B9\u03C3\u03C4\u03B5\u03C5\u03C4\u03B5\u03AF\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03CC \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE \u03C4\u03BF\u03C5 \u03AC\u03BD\u03B5\u03C4\u03BF\u03C5 \u03C3\u03C0\u03B9\u03C4\u03B9\u03BF\u03CD \u03C3\u03B1\u03C2.',
    'svc.business': '\u0395\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03B9\u03BA\u03AC \u039A\u03C4\u03AF\u03C1\u03B9\u03B1 & \u039E\u03B5\u03BD\u03BF\u03B4\u03BF\u03C7\u03B5\u03AF\u03B1',
    'svc.business_desc': '\u039C\u03B1\u03B6\u03AF \u03B8\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03BF\u03C5\u03BC\u03B5 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B1\u03BB\u03BB\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03B7 \u03B5\u03C0\u03AD\u03BD\u03B4\u03C5\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C3\u03B1\u03C2 \u03AE \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03AE \u03C3\u03B1\u03C2.',
    'svc.masonry': '\u03A4\u03BF\u03B9\u03C7\u03BF\u03C0\u03BF\u03B9\u03AF\u03B1',
    'svc.masonry_desc': '\u0397 \u03C4\u03BF\u03B9\u03C7\u03BF\u03C0\u03BF\u03B9\u03AF\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BC\u03AD\u03BD\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03B7\u03C4\u03AE \u03BB\u03CC\u03B3\u03C9 \u03C3\u03C4\u03B1\u03B8\u03B5\u03C1\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03B4\u03B9\u03B1\u03C1\u03BA\u03B5\u03AF\u03B1\u03C2.',
    'svc.plastering': '\u0393\u03CD\u03C8\u03B9\u03BD\u03BF',
    'svc.plastering_desc': '\u03A4\u03BF \u03B3\u03CD\u03C8\u03B9\u03BD\u03BF \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF \u03BC\u03B9\u03B1 \u03BB\u03B5\u03AF\u03B1 \u03B5\u03C0\u03B9\u03BA\u03AC\u03BB\u03C5\u03C8\u03B7 \u03C0\u03AC\u03BD\u03C9 \u03C3\u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B5\u03C1\u03B3\u03B1\u03C3\u03BC\u03AD\u03BD\u03B7 \u03B5\u03C0\u03B9\u03C6\u03AC\u03BD\u03B5\u03B9\u03B1.',
    'svc.painting': '\u0392\u03AC\u03C8\u03B9\u03BC\u03BF',
    'svc.painting_desc': '\u0394\u03B9\u03AC\u03C6\u03BF\u03C1\u03BF\u03B9 \u03C0\u03B1\u03C1\u03AC\u03B3\u03BF\u03BD\u03C4\u03B5\u03C2 \u03B5\u03C0\u03B7\u03C1\u03B5\u03AC\u03B6\u03BF\u03C5\u03BD \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7 \u03B2\u03B1\u03C6\u03AE.',
    'svc.tiling': '\u03A4\u03BF\u03C0\u03BF\u03B8\u03AD\u03C4\u03B7\u03C3\u03B7 \u03A0\u03BB\u03B1\u03BA\u03B9\u03B4\u03AF\u03C9\u03BD',
    'svc.tiling_desc': '\u0397 \u03C4\u03BF\u03C0\u03BF\u03B8\u03AD\u03C4\u03B7\u03C3\u03B7 \u03C0\u03BB\u03B1\u03BA\u03B9\u03B4\u03AF\u03C9\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B9\u03B1 \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03B1\u03C3\u03AF\u03B1 \u03C3\u03C4\u03B1 \u03C3\u03C5\u03BD\u03B7\u03B8\u03B9\u03C3\u03BC\u03AD\u03BD\u03B1 \u03B5\u03C4\u03B1\u03C0 \u03B1\u03BD\u03B1\u03BA\u03B1\u03AF\u03BD\u03B9\u03C3\u03B7\u03C2.',
    'svc.drywall': '\u03A3\u03C5\u03BD\u03B8\u03B5\u03C4\u03B9\u03BA\u03AE \u039F\u03C1\u03BF\u03C6\u03AE',
    'svc.drywall_desc': '\u0397 \u03C3\u03C5\u03BD\u03B8\u03B5\u03C4\u03B9\u03BA\u03AE \u03BF\u03C1\u03BF\u03C6\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03C5\u03BB\u03B9\u03BA\u03AC \u03C0\u03BF\u03C5 \u03B5\u03C0\u03B1\u03BD\u03B1\u03C3\u03C4\u03AC\u03C4\u03B7\u03C3\u03B1\u03BD \u03C4\u03B7 \u03C3\u03CD\u03B3\u03C7\u03C1\u03BF\u03BD\u03B7 \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE.',
    'svc.insulation': '\u0398\u03B5\u03C1\u03BC\u03BF\u03BC\u03CC\u03BD\u03C9\u03C3\u03B7',
    'svc.insulation_desc': '\u0397 \u03B8\u03B5\u03C1\u03BC\u03BF\u03BC\u03CC\u03BD\u03C9\u03C3\u03B7 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B2\u03B1\u03C3\u03B9\u03BA\u03CC \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03C4\u03B7\u03C2 \u03C3\u03CD\u03B3\u03C7\u03C1\u03BF\u03BD\u03B7\u03C2 \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE\u03C2.',
    'svc.plumbing': '\u03A5\u03B4\u03C1\u03B1\u03C5\u03BB\u03B9\u03BA\u03AD\u03C2 \u0395\u03B3\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2',
    'svc.plumbing_desc': '\u039F\u03B9 \u03C5\u03B4\u03C1\u03B1\u03C5\u03BB\u03B9\u03BA\u03AD\u03C2 \u03B5\u03B3\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03B5 \u03BC\u03B5\u03B3\u03AC\u03BB\u03B7 \u03B6\u03AE\u03C4\u03B7\u03C3\u03B7.',
    'svc.electrical': '\u0397\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03AD\u03C2 \u0395\u03B3\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2',
    'svc.electrical_desc': '\u039F\u03B9 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03AD\u03C2 \u03B5\u03B3\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03BE\u03B5\u03BA\u03B9\u03BD\u03BF\u03CD\u03BD \u03B1\u03C0\u03CC \u03C4\u03BF \u03B1\u03C1\u03C7\u03B9\u03BA\u03CC \u03C3\u03C4\u03AC\u03B4\u03B9\u03BF \u03C4\u03BF\u03C5 \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD.',
    'svc.demolition': '\u039A\u03B1\u03C4\u03B5\u03B4\u03AC\u03C6\u03B9\u03C3\u03B7 & \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC',
    'svc.demolition_desc': '\u0397 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03B5\u03B9 \u03BA\u03B1\u03C4\u03B5\u03B4\u03AC\u03C6\u03B9\u03C3\u03B7, \u03BA\u03B1\u03B8\u03B1\u03C1\u03B9\u03C3\u03BC\u03CC \u03BA\u03B1\u03B9 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03B1\u03C0\u03BF\u03B2\u03BB\u03AE\u03C4\u03C9\u03BD.',

    // About
    'about.title': '\u03A3\u03C7\u03B5\u03C4\u03B9\u03BA\u03AC \u03BC\u03B5 \u03C4\u03B7\u03BD GreenCastle',
    'about.hero_subtitle': '\u0397 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03C0\u03B9\u03BA\u03B5\u03BD\u03C4\u03C1\u03C9\u03BC\u03AD\u03BD\u03B7 \u03C3\u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE \u03C3\u03CD\u03B3\u03C7\u03C1\u03BF\u03BD\u03C9\u03BD, \u03C5\u03C8\u03B7\u03BB\u03AE\u03C2 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03BF\u03B9\u03BA\u03B9\u03C3\u03C4\u03B9\u03BA\u03CE\u03BD \u03AD\u03C1\u03B3\u03C9\u03BD.',
    'about.reliable_partner': '\u039F \u03B1\u03BE\u03B9\u03CC\u03C0\u03B9\u03C3\u03C4\u03BF\u03C2 \u03C3\u03C5\u03BD\u03B5\u03C1\u03B3\u03AC\u03C4\u03B7\u03C2 \u03C3\u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE',
    'about.text1': '\u0397 GreenCastle \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B9\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 \u03BC\u03B5 \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1\u03C2 \u03C3\u03C4\u03BF\u03BD \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03CC \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE \u03BA\u03B1\u03C4\u03BF\u03B9\u03BA\u03B9\u03CE\u03BD.',
    'about.text2': '\u0394\u03B5\u03C3\u03BC\u03B5\u03C5\u03CC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03B1\u03C1\u03AD\u03C7\u03BF\u03C5\u03BC\u03B5 \u03C5\u03C8\u03B7\u03BB\u03AE \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE\u03C2 \u03BC\u03B5 \u03B1\u03BD\u03C4\u03B1\u03B3\u03C9\u03BD\u03B9\u03C3\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C4\u03B9\u03BC\u03AD\u03C2.',
    'about.text3': '\u0397 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BC\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BD\u03B1 \u03BA\u03C4\u03AF\u03B6\u03BF\u03C5\u03BC\u03B5 \u03BA\u03B1\u03C4\u03BF\u03B9\u03BA\u03AF\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03C5\u03C0\u03B5\u03C1\u03B2\u03B1\u03AF\u03BD\u03BF\u03C5\u03BD \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03B4\u03BF\u03BA\u03AF\u03B5\u03C2 \u03C4\u03C9\u03BD \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD \u03BC\u03B1\u03C2.',
    'about.years_exp': '\u03C7\u03C1\u03CC\u03BD\u03B9\u03B1 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1\u03C2',
    'about.values_title': '\u039F\u03B9 \u0391\u03BE\u03AF\u03B5\u03C2 \u03BC\u03B1\u03C2',
    'about.values_subtitle': '\u039F\u03B9 \u03B1\u03C1\u03C7\u03AD\u03C2 \u03C0\u03BF\u03C5 \u03BC\u03B1\u03C2 \u03BA\u03B1\u03C4\u03B5\u03C5\u03B8\u03CD\u03BD\u03BF\u03C5\u03BD \u03C3\u03C4\u03B7\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03BC\u03B1\u03C2',
    'about.quality': '\u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1',
    'about.quality_desc': '\u03A3\u03B5 \u03BA\u03AC\u03B8\u03B5 \u03C3\u03C4\u03AC\u03B4\u03B9\u03BF \u03B5\u03B3\u03B3\u03C5\u03B1\u03C4\u03AC\u03C3\u03C4\u03B5 \u03C5\u03C8\u03B7\u03BB\u03AE \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03CD\u03BC\u03C6\u03C9\u03BD\u03B1 \u03BC\u03B5 \u03B5\u03C5\u03C1\u03C9\u03C0\u03B1\u03CA\u03BA\u03AC \u03C0\u03C1\u03CC\u03C4\u03C5\u03C0\u03B1.',
    'about.precision': '\u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1',
    'about.precision_desc': '\u03A0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03BF\u03C5\u03BC\u03B5 \u03BF\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03AC \u03BB\u03CD\u03C3\u03B5\u03B9\u03C2 \u03BC\u03AD\u03C3\u03C9 \u03C4\u03B7\u03C2 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1\u03C2 \u03BC\u03B1\u03C2 \u03C3\u03C4\u03BF\u03BD \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03CC.',
    'about.customer_care': '\u0395\u03BE\u03C5\u03C0\u03B7\u03C1\u03AD\u03C4\u03B7\u03C3\u03B7 \u03A0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD',
    'about.customer_care_desc': '\u0395\u03AF\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C0\u03BB\u03AE\u03C1\u03C9\u03C2 \u03C3\u03C5\u03BD\u03C4\u03BF\u03BD\u03B9\u03C3\u03BC\u03AD\u03BD\u03BF\u03B9 \u03BC\u03B5 \u03C4\u03B9\u03C2 \u03B1\u03BD\u03AC\u03B3\u03BA\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C4\u03C9\u03BD \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD \u03BC\u03B1\u03C2.',
    'about.reliability': '\u0391\u03BE\u03B9\u03BF\u03C0\u03B9\u03C3\u03C4\u03AF\u03B1',
    'about.reliability_desc': '\u0395\u03B3\u03B3\u03C5\u03CC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03BC\u03C0\u03C1\u03CC\u03B8\u03B5\u03C3\u03BC\u03B7 \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03C9\u03BD \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03B9\u03CE\u03BD. \u03A4\u03B7\u03C1\u03BF\u03CD\u03BC\u03B5 \u03C0\u03AC\u03BD\u03C4\u03BF\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C5\u03C0\u03BF\u03C3\u03C7\u03AD\u03C3\u03B5\u03B9\u03C2 \u03BC\u03B1\u03C2.',
    'about.certs_title': '\u03A0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03C4\u03B9\u03BA\u03AC & \u03A0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2',
    'about.certs_subtitle': '\u039F\u03B9 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2 \u03BC\u03B1\u03C2',
    'about.team_title': '\u0397 \u039F\u03BC\u03AC\u03B4\u03B1 \u03BC\u03B1\u03C2',
    'about.team_subtitle': '\u0395\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03AF\u03B5\u03C2 \u03BC\u03B5 \u03B5\u03BA\u03C4\u03B5\u03BD\u03AE \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03C3\u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD \u03B1\u03C1\u03C7\u03B9\u03C4\u03B5\u03BA\u03C4\u03BF\u03BD\u03B9\u03BA\u03AE',
    'about.partners_title': '\u039F\u03B9 \u03A3\u03C5\u03BD\u03B5\u03C1\u03B3\u03AC\u03C4\u03B5\u03C2 \u03BC\u03B1\u03C2',
    'about.partners_subtitle': '\u03A3\u03C5\u03BD\u03B5\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03BC\u03B5 \u03BA\u03BF\u03C1\u03C5\u03C6\u03B1\u03AF\u03B5\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B5\u03C2 \u03C4\u03BF\u03C5 \u03BA\u03BB\u03AC\u03B4\u03BF\u03C5',

    // Contact
    'contact.title': '\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2',
    'contact.subtitle': '\u0397 \u03BF\u03BC\u03AC\u03B4\u03B1 \u03BC\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C4\u03B7 \u03B4\u03B9\u03AC\u03B8\u03B5\u03C3\u03AE \u03C3\u03B1\u03C2.',
    'contact.info_title': '\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1\u03C2',
    'contact.address': '\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7',
    'contact.phone': '\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF',
    'contact.email': 'Email',
    'contact.working_hours': '\u03A9\u03C1\u03AC\u03C1\u03B9\u03BF \u039B\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1\u03C2',
    'contact.hours_value': '\u0394\u03B5\u03C5 - \u03A0\u03B1\u03C1: 9:00 - 18:00',
    'contact.sales_dept': '\u03A4\u03BC\u03AE\u03BC\u03B1 \u03A0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD',
    'contact.find_us': '\u0392\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2',
    'contact.form_title': '\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u0395\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7\u03C2',
    'contact.form_subtitle': '\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03C6\u03CC\u03C1\u03BC\u03B1 \u03BA\u03B1\u03B9 \u03B8\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BC\u03B1\u03B6\u03AF \u03C3\u03B1\u03C2 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1.',

    // Inquiry Form
    'form.name': '\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03AC \u03C3\u03B1\u03C2',
    'form.email': 'Email',
    'form.phone': '\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF',
    'form.message': '\u039C\u03AE\u03BD\u03C5\u03BC\u03B1',
    'form.submit': '\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u0395\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7\u03C2',
    'form.sending': '\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE...',
    'form.success_title': '\u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5!',
    'form.success_msg': '\u0397 \u03B5\u03C1\u03CE\u03C4\u03B7\u03C3\u03AE \u03C3\u03B1\u03C2 \u03B1\u03C0\u03B5\u03C3\u03C4\u03AC\u03BB\u03B7 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03CE\u03C2. \u0398\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BC\u03B1\u03B6\u03AF \u03C3\u03B1\u03C2 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1.',
    'form.new_inquiry': '\u039D\u03AD\u03B1 \u03B5\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7',
    'form.inquiry_for': '\u0395\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7 \u03B3\u03B9\u03B1',
    'form.min_length': '\u03A4\u03BF \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD 10 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.',
    'form.too_many': '\u03A0\u03BF\u03BB\u03BB\u03AD\u03C2 \u03B1\u03B9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2. \u03A0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5 \u03BB\u03AF\u03B3\u03B1 \u03BB\u03B5\u03C0\u03C4\u03AC.',
    'form.error': '\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7\u03BD \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.',
    'form.placeholder_name': '\u0393\u03B9\u03CE\u03C1\u03B3\u03B7\u03C2 \u03A0\u03B1\u03C0\u03B1\u03B4\u03CC\u03C0\u03BF\u03C5\u03BB\u03BF\u03C2',
    'form.placeholder_email': 'giorgos@example.com',
    'form.placeholder_phone': '+30 210 123 4567',
    'form.placeholder_message': '\u0395\u03BD\u03B4\u03B9\u03B1\u03C6\u03AD\u03C1\u03BF\u03BC\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C3\u03C7\u03B5\u03C4\u03B9\u03BA\u03AC \u03BC\u03B5...',

    // Login
    'login.title': '\u0395\u03AF\u03C3\u03BF\u03B4\u03BF\u03C2 \u03C3\u03C4\u03BF \u03C3\u03CD\u03C3\u03C4\u03B7\u03BC\u03B1',
    'login.subtitle': '\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B1 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C3\u03B1\u03C2',
    'login.email': 'Email',
    'login.password': '\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2',
    'login.submit': '\u0395\u03AF\u03C3\u03BF\u03B4\u03BF\u03C2',
    'login.loading': '\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7...',
    'login.back': '\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03BF\u03BD \u03B9\u03C3\u03C4\u03CC\u03C4\u03BF\u03C0\u03BF',
    'login.success': '\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE\u03C2 \u03B5\u03AF\u03C3\u03BF\u03B4\u03BF\u03C2!',
    'login.error': '\u039A\u03AC\u03C4\u03B9 \u03C0\u03AE\u03B3\u03B5 \u03BB\u03AC\u03B8\u03BF\u03C2. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.',

    // Footer
    'footer.description': '\u0397 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03C0\u03B9\u03BA\u03B5\u03BD\u03C4\u03C1\u03C9\u03BC\u03AD\u03BD\u03B7 \u03C3\u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE \u03C3\u03CD\u03B3\u03C7\u03C1\u03BF\u03BD\u03C9\u03BD, \u03C5\u03C8\u03B7\u03BB\u03AE\u03C2 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03BF\u03B9\u03BA\u03B9\u03C3\u03C4\u03B9\u03BA\u03CE\u03BD \u03AD\u03C1\u03B3\u03C9\u03BD.',
    'footer.quick_links': '\u0393\u03C1\u03AE\u03B3\u03BF\u03C1\u03BF\u03B9 \u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03B9',
    'footer.our_projects': '\u03A4\u03B1 \u0388\u03C1\u03B3\u03B1 \u03BC\u03B1\u03C2',
    'footer.current_projects': '\u03A4\u03C1\u03AD\u03C7\u03BF\u03BD\u03C4\u03B1 \u0388\u03C1\u03B3\u03B1',
    'footer.contacts': '\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1',
    'footer.privacy': '\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u0391\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5',
    'footer.terms': '\u038C\u03C1\u03BF\u03B9 \u03A7\u03C1\u03AE\u03C3\u03B7\u03C2',
    'footer.rights': '\u03A0\u03B1\u03BD\u03C4\u03B1 \u03C4\u03B1 \u03B4\u03B9\u03BA\u03B1\u03B9\u03CE\u03BC\u03B1\u03C4\u03B1 \u03B1\u03C0\u03BF\u03B8\u03B5\u03BC\u03B1\u03C4\u03B1.',
    'footer.loading': '\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7...',
    'footer.sales_dept': '\u03A4\u03BC\u03AE\u03BC\u03B1 \u03A0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD',

    // Admin Navigation
    // ── Admin Page Translations ──────────────────────────────
    'settings.page_title': 'Ρυθμίσεις ιστοτόπου',
    'settings.page_subtitle': 'Διαχειριστείτε τις κύριες ρυθμίσεις',
    'settings.save_all': 'Αποθήκευση όλων',
    'settings.saved': 'Ρυθμίσεις αποθηκεύτηκαν!',
    'settings.save_error': 'Σφάλμα αποθήκευσης',
    'settings.tab.hero': 'Hero Παρουσίαση',
    'settings.tab.contact': 'Επαφές και Τοποθεσία',
    'settings.tab.maps': 'Google Maps',
    'settings.tab.ai': 'AI Ενσωμάτωση',
    'settings.slideshow.subtitle': 'Οι διαφάνειες εμφανίζονται στην αρχική',
    'settings.slideshow.add_slide': 'Προσθήκη διαφάνειας',
    'settings.slideshow.settings': 'Ρυθμίσεις παρουσίασης',
    'settings.slideshow.speed': 'Ταχύτητα (δευτ.)',
    'settings.slideshow.order': 'Σειρά εμφάνισης',
    'settings.slideshow.sequential': 'Σειριακά',
    'settings.slideshow.random': 'Τυχαία',
    'settings.slideshow.transition': 'Μετάβαση',
    'settings.slideshow.fade': 'Ομαλή (fade)',
    'settings.slideshow.slide': 'Διαφάνεια',
    'settings.slideshow.autoplay': 'Αυτόματη αναπαραγωγή',
    'settings.image': 'Εικόνα',
    'settings.image_url': 'URL εικόνας',
    'settings.title_label': 'Τίτλος',
    'settings.title_placeholder': 'Τίτλος διαφάνειας',
    'settings.subtitle_label': 'Υπότιτλος / Περιγραφή',
    'settings.subtitle_placeholder': 'Σύντομη περιγραφή',
    'settings.cta_text': 'Κείμενο κουμπιού',
    'settings.cta_link': 'Σύνδεσμος κουμπιού',
    'settings.no_slides': 'Δεν υπάρχουν διαφάνειες',
    'settings.add_first_slide': 'Προσθήκη πρώτης διαφάνειας',
    'settings.contact.title': 'Στοιχεία επικοινωνίας',
    'settings.contact.address': 'Διεύθυνση γραφείου',
    'settings.contact.phone_office': 'Τηλέφωνο (γραφείο)',
    'settings.contact.email_office': 'Email (γραφείο)',
    'settings.contact.phone_sales': 'Τηλέφωνο (πωλήσεις)',
    'settings.contact.email_sales': 'Email (πωλήσεις)',
    'settings.contact.extra_phone_1': 'Επιπλέον τηλέφωνο 1',
    'settings.contact.extra_email_1': 'Επιπλέον email 1',
    'settings.contact.extra_phone_2': 'Επιπλέον τηλέφωνο 2',
    'settings.contact.extra_email_2': 'Επιπλέον email 2',
    'settings.contact.optional': 'Αφήστε κενό αν δεν χρειάζεται',
    'settings.contact.extra_socials': 'Επιπλέον κοινωνικά δίκτυα',
    'settings.contact.add_network': 'Προσθήκη δικτύου',
    'settings.location.title': 'Τοποθεσία γραφείου',
    'settings.location.subtitle': 'Οι συντεταγμένες καθορίζουν τη θέση',
    'settings.location.lat': 'Γεωγρ. πλάτος',
    'settings.location.lng': 'Γεωγρ. μήκος',
    'settings.location.map_preview': 'Προεπισκόπηση χάρτη',
    'settings.maps.title': 'Κλειδί Google Maps API',
    'settings.maps.api_key_label': 'Κλειδί API',
    'settings.ai.section_title': 'AI Ενσωμάτωση',
    'settings.tracking.title': 'Παρακολούθηση & Ανάλυση',
    'props.page_title': 'Διαχείριση ακινήτων',
    'props.page_subtitle': 'Έργα, κτίρια, όροφοι και διαμερίσματα',
    'props.new_project': 'Νέο Έργο',
    'props.edit_project': 'Επεξεργασία έργου',
    'props.add_building': 'Κτίριο',
    'props.category': 'Κατηγορία',
    'props.status.active': 'Υπό κατασκευή',
    'props.status.upcoming': 'Προσεχώς',
    'props.status.completed': 'Ολοκληρώθηκε',
    'props.cat.residential': 'Κατοικία',
    'about_admin.page_title': 'Σελίδα Σχετικά',
    'about_admin.page_subtitle': 'Διαχείριση περιεχομένου',
    'about_admin.description': 'Περιγραφή',
    'about_admin.company_text': 'Κείμενο εταιρείας',
    'about_admin.our_team': 'Η ομάδα μας',
    'about_admin.certifications': 'Πιστοποιητικά',
    'inquiries.page_subtitle': 'Προβολή και διαχείριση',
    'inquiries.activate_notifs': 'Ενεργοποίηση email',
    'inquiries.no_recipients': 'Δεν υπάρχουν παραλήπτες',
    'inquiries.send_test_email': 'Αποστολή δοκιμαστικού email',
    'services_admin.subtitle': 'Διαχείριση υπηρεσιών',
    'services_admin.icon': 'Εικονίδιο',
    'reports.title': 'Αναφορές και Καταγραφές',
    'reports.no_reports': 'Δεν υπάρχουν αναφορές',
    'reports.view_report': 'Προβολή αναφοράς',
    'reports.period': 'Δεδομένα περιόδου',
    'reports.format': 'Μορφή',
    'common.close': 'Κλείσιμο',
    'common.cancel': 'Ακύρωση',
    'common.save': 'Αποθήκευση',
    'common.add': 'Προσθήκη',
    'common.delete': 'Διαγραφή',
    'common.edit': 'Επεξεργασία',
    'common.loading': 'Φόρτωση...',
    'common.no_data': 'Δεν υπάρχουν δεδομένα',
    'props.cat.commercial': 'Εμπορικό',
    'props.cat.hotel': 'Ξενοδοχείο',
    'props.images_hint': '1η = Logo · 2η = Cover · σύρετε',
    'props.documents': 'Έγγραφα',
    'props.social_networks': 'Κοινωνικά δίκτυα',
    'props.uploading': 'Μεταφόρτωση...',
    'props.create': 'Δημιουργία',
    'props.edit_building': 'Επεξεργασία κτιρίου',
    'props.new_building': 'Νέο Κτίριο',
    'props.edit_floor': 'Επεξεργασία ορόφου',
    'props.new_floor': 'Νέος Όροφος',
    'props.edit_apt': 'Επεξεργασία διαμερίσματος',
    'props.new_apt': 'Νέο Διαμέρισμα',
    'props.apt.available': 'Διαθέσιμο',
    'props.apt.reserved': 'Κρατημένο',
    'props.apt.sold': 'Πουλήθηκε',
    'props.floor_number': 'Αριθμός ορόφου',
    'props.floor_description': 'Περιγραφή ορόφου',
    'props.floor_photos': 'Φωτογραφίες κοινόχρηστων χώρων',
    'props.apt_number': 'Αριθμός',
    'dashboard.morning': 'Καλημέρα',
    'dashboard.afternoon': 'Καλό απόγευμα',
    'dashboard.evening': 'Καλό βράδυ',
    'dashboard.welcome': 'Καλωσορίσατε',
    'dashboard.manage_listings': 'Διαχειριστείτε τις αγγελίες',
    'dashboard.last_6months': 'τελευταίους 6 μήνες',
    'dashboard.inquiries_by_month': 'Ερωτήσεις ανά μήνα',
    'dashboard.by_status': 'Κατανομή ανά κατάσταση',
    'dashboard.latest_inquiries': 'Τελευταίες ερωτήσεις',
    'dashboard.quick_actions': 'Γρήγορες ενέργειες',
    'listings.admin_title': 'Αγγελίες ακινήτων',
    'listings.new_listing': 'Νέα Αγγελία',
    'listings.edit_listing': 'Επεξεργασία αγγελίας',
    'listings.area_label': 'Εμβαδόν',
    'listings.rooms_label': 'Δωμάτια',
    'listings.floor_label': 'Όροφος',
    'listings.year_label': 'Έτος',
    'listings.features': 'Χαρακτηριστικά',
    'listings.sale_or_rent': 'Πώληση ή ενοικίαση',
    'inquiries.title': 'Ερωτήσεις',
    'inquiries.email_notifs': 'Ειδοποιήσεις email',
    'inquiries.all': 'Όλα',
    'props.project_name': 'Όνομα έργου',
    'props.building_name': 'Όνομα κτιρίου',
    'props.floors_count': 'Αριθμός ορόφων',
    'props.blueprint': 'Κάτοψη / Σχέδιο',
    'props.building_photos': 'Φωτογραφίες κτιρίου',
    'props.apts_count': 'Αριθμός διαμερισμάτων',
    'props.upload_btn': 'Μεταφόρτωση',
    'props.upload_blueprint': 'Μεταφόρτωση κατόψεως',
    'inquiries.sender_name': 'Όνομα αποστολέα',
    'inquiries.use_tls': 'Χρήση TLS/SSL',
    'dashboard.apartments': 'Διαμερίσματα',
    'inquiries.new': 'Νέα',
    'inquiries.read': 'Αναγνωσμένα',
    'inquiries.replied': 'Απαντημένα',
    'inquiries.send_test': 'Αποστολή δοκιμής',
    'inquiries.save_settings': 'Αποθήκευση ρυθμίσεων',
    'inquiries.recipients': 'Παραλήπτες ειδοποιήσεων',
    'inquiries.smtp_settings': 'Ρυθμίσεις SMTP',
    'inquiries.smtp_server': 'Διακομιστής SMTP',
    'inquiries.smtp_port': 'Θύρα',
    'inquiries.smtp_user': 'Χρήστης',
    'inquiries.smtp_password': 'Κωδικός',
    'inquiries.smtp_sender': 'Αποστολέας',
    'inquiries.no_inquiries': 'Δεν υπάρχουν ερωτήσεις',
    'inquiries.status.new': 'Νέο',
    'inquiries.status.read': 'Αναγνωσμένο',
    'inquiries.status.replied': 'Απαντήθηκε',
    'users.title': 'Χρήστες',
    'users.new_user': 'Νέος χρήστης',
    'users.edit_user': 'Επεξεργασία χρήστη',
    'users.system_account': 'Λογαριασμός συστήματος',
    'users.change_password': 'Αλλαγή κωδικού',
    'dashboard.residential_complexes': 'κατοικίες',
    'listings.neighborhood_label': 'Γειτονιά',
    'listings.neighborhood_hint': 'Μόνο γειτονιά',
    'listings.all_neighborhoods': 'Όλες οι γειτονιές',
    'listings.in_neighborhood': 'στη γειτονιά',
    'listings.clear_filters': 'Καθαρισμός φίλτρων',
    'dashboard.in_all_projects': 'σε όλα τα έργα',
    'dashboard.sale_and_rent': 'πώληση και ενοικίαση',
    'dashboard.from_clients': 'από πελάτες',
    'users.role.admin': 'Διαχειριστής',
    'users.role.manager': 'Διευθυντής',
    'users.role.editor': 'Συντάκτης',
    'users.role.broker': 'Μεσίτης',
    'about_admin.title': 'Σχετικά με εμάς',
    'about_admin.team': 'Ομάδα',
    'about_admin.partners': 'Συνεργάτες',
    'about_admin.certificates': 'Πιστοποιητικά',
    'about_admin.add_member': 'Προσθήκη μέλους',
    'about_admin.add_partner': 'Προσθήκη συνεργάτη',
    'about_admin.add_cert': 'Προσθήκη πιστοποιητικού',
    'services_admin.title': 'Υπηρεσίες',
    'admin.panel': '\u03A0\u03AF\u03BD\u03B1\u03BA\u03B1\u03C2 \u0394\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7\u03C2',
    'admin.dashboard': '\u03A0\u03AF\u03BD\u03B1\u03BA\u03B1\u03C2',
    'admin.main': '\u039A\u03CD\u03C1\u03B9\u03BF',
    'admin.site': '\u0399\u03C3\u03C4\u03CC\u03C4\u03BF\u03C0\u03BF\u03C2',
    'admin.settings': '\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03B9\u03C2 (\u0391\u03C1\u03C7\u03B9\u03BA\u03AE)',
    'admin.projects': '\u0388\u03C1\u03B3\u03B1',
    'admin.listings_nav': '\u0391\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2 \u0391\u03BA\u03B9\u03BD\u03AE\u03C4\u03C9\u03BD',
    'admin.services_nav': '\u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2',
    'admin.about_nav': '\u03A3\u03C7\u03B5\u03C4\u03B9\u03BA\u03AC \u03BC\u03B5 \u03B5\u03BC\u03AC\u03C2',
    'admin.contacts_section': '\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1 & \u0395\u03C1\u03C9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2',
    'admin.contacts_nav': '\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1',
    'admin.inquiries_nav': '\u0395\u03C1\u03C9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2',
    'admin.reports_nav': '\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AD\u03C2',
    'admin.administration': '\u0394\u03B9\u03BF\u03AF\u03BA\u03B7\u03C3\u03B7',
    'admin.users_nav': '\u03A7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2',
    'admin.view_site': '\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u0399\u03C3\u03C4\u03CC\u03C4\u03BF\u03C0\u03BF\u03C5',
    'admin.language': '\u0393\u03BB\u03CE\u03C3\u03C3\u03B1',
    'admin.save': '\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7',
    'admin.cancel': '\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7',
    'admin.delete': '\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE',
    'admin.edit': '\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1',
    'admin.add': '\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7',
    'admin.create': '\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1',
    'admin.search': '\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7...',
    'admin.confirm_delete': '\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5;',
    'admin.yes_delete': '\u039D\u03B1\u03B9, \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE',
    'admin.no_cancel': '\u038C\u03C7\u03B9, \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7',
    'admin.loading': '\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7...',
    'admin.saving': '\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7...',
    'admin.success': '\u0391\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C4\u03B7\u03BA\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03CE\u03C2!',
    'admin.error': '\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.',
    'admin.no_data': '\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1',
    'admin.status': '\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7',
    'admin.actions': '\u0395\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B5\u03C2',
    'admin.preview': '\u03A0\u03C1\u03BF\u03B5\u03C3\u03BA\u03CC\u03C0\u03B7\u03C3\u03B7',
    'admin.upload_image': '\u039C\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u0395\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2',
    'admin.drag_reorder': '\u03A3\u03CD\u03C1\u03B5\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03B1\u03BD\u03B1\u03B4\u03B9\u03AC\u03C4\u03B1\u03BE\u03B7',
    'admin.cover_photo': '\u0395\u03BE\u03CE\u03C6\u03C5\u03BB\u03BB\u03BF \u03A6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1',
    'listings.type_label': 'Τύπος αγγελίας',
    'listings.admin_subtitle': 'Διαχείριση αγγελιών',
    'listings.broker_own_only': 'Βλέπετε μόνο τις δικές σας αγγελίες',
    'listings.no_listings': 'Δεν υπάρχουν αγγελίες',
    'listings.create_first': 'Δημιουργήστε την πρώτη αγγελία',
    'listings.contact_name': 'Επαφή - Όνομα',
    'listings.contact_phone': 'Επαφή - Τηλέφωνο',
    'listings.contact_email': 'Επαφή - Email',
    'listings.features_hint': 'Διαχωρίστε με κόμμα',
    'listings.all_cities': 'Όλες οι πόλεις',
    'listings.all_neighborhoods': 'Όλες οι γειτονιές',
    'listings.in_neighborhood': 'στη γειτονιά',
    'listings.clear_filters': 'Καθαρισμός φίλτρων',
    'listings.neighborhood_label': 'Γειτονιά',
    'listings.neighborhood_hint': 'Μόνο γειτονιά',
    'admin.title': 'Τίτλος',
    'admin.location': 'Τοποθεσία / Πόλη',
    'admin.description': 'Περιγραφή',
    'admin.name': 'Όνομα',
    'admin.email': 'Email',
    'admin.phone': 'Τηλέφωνο',
    'admin.role': 'Ρόλος',
    'admin.price': 'Τιμή',
    'admin.created_at': 'Δημιουργήθηκε',
    'admin.add_new': 'Προσθήκη νέου',
    'admin.upload_images': 'Μεταφόρτωση εικόνων',
  }
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('gc_lang') || 'bg';
  });

  useEffect(() => {
    localStorage.setItem('gc_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key, fallback) => {
    return translations[lang]?.[key] || translations['bg']?.[key] || fallback || key;
  }, [lang]);

  const switchLang = useCallback((newLang) => {
    if (SUPPORTED_LANGS.find(l => l.code === newLang)) {
      setLang(newLang);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, t, switchLang, SUPPORTED_LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useTranslation must be used within LanguageProvider');
  return ctx;
}

export { SUPPORTED_LANGS };
